import { computed } from 'vue'
import { defineStore } from 'pinia'
import { useLangStore } from '@/stores/lang'

export const useTranslaterStore = defineStore('translater', () => {

    const langStore = useLangStore()

    const translates = {

        RU: {

            YES:                        'Да', 
            NO:                         'Нет', 

            BTN_ADD:                    'Добавить',
            BTN_CREATE:                 'Создать',
            BTN_SELECT:                 'Выбрать', 
            BTN_EDIT:                   'Редактировать',
            BTN_CTRL:                   'Управление',
            BTN_SAVE:                   'Сохранить',
            BTN_UPDATE:                 'Обновить', 
            BTN_CANCEL:                 'Отмена',
            BTN_DELETE:                 'Удалить',
            BTN_REQUEST:                'Запросить', 
            BTN_FAVORITES:              'Избранное', 
            BTN_READMORE:               'Подробнее', 
            BTN_UPLOAD:                 'Загрузить', 
            BTN_SEND:                   'Послать', 
            BTN_CLOSE:                  'Закрыть', 
            BTN_MAP:                    'Карта', 
            BTN_REISSUE:                'Перевыпустить', 
            BTN_SELECT_END:             'Закончить выбор', 

            // Единицы измерений
            UNIT_KM:                    'км',
            UNIT_KMH:                   'км/ч',
            UNIT_METRE:                 'м',
            UNIT_DAY:                   'д.',
            UNIT_HOUR:                  'ч.',
            UNIT_MINUTE:                'мин.',
            UNIT_SECOND:                'с',
            UNIT_SECOND_LONG:           'сек.',
            UNIT_MLITER:                'мл',
            UNIT_LITER:                 'л',
            UNIT_LITER_100_KM:          'л/100км',
            UNIT_ATM:                   'атм',
            UNIT_RPM:                   'об/мин',
            UNIT_VOLT:                  'В',

            ONLINE:                     'На связи',
            OFFLINE:                    'Нет связи',

            ATTRS:                      'Атрибуты', 
            ATTRS_DEVELOPER:            'Режим разработчика', 
            ATTR_LOGS_CAR:              'Просмотр логов автомобилей', 
            ATTR_EDIT_PRIVATE_CAR:      'Редактирование данных производителя', 
            ATTR_GEODATA:               'Навигационная информация', 
            ATTR_REMOTE_CONTROL:        'Удаленное управление', 
            ATTR_DIAGNOSTIC:            'Отчёты ЭБУ', 
            ATTR_PARAM:                 'Управление параметрами GNSS', 
            ATTR_FIRMWARE:              'Работа с прошивками', 
            ATTR_MULTI_FIRMWARE:        'Массовая прошивка',
            ATTR_COMMAND:               'Отправка комманд GNSS', 
            ATTR_GROUP_ADMIN:           'Админ группы пользователей', 
            ATTR_SUPER_ADMIN:           'Администратор приложения', 
            ATTR_CREATOR_CAR:           'Создание автомобилей', 
            ATTR_SEER_CAR:              'Просмотр всех автомобилей', 
            ATTR_CERTIFICATE_ADMIN:     'Управление сертификатами', 

            CERTIFICATES:                   'Сертификаты', 
            CERTIFICATE:                    'Сертификат', 
            CERTIFICATES_ISSUE:             'Выпустить', 
            CERTIFICATES_CRT:               'Crt',
            CERTIFICATES_KEY:               'Key',  
            CERTIFICATES_CREATE:            'Выпуск сертификата', 
            CERTIFICATES_CREATE_SUCCESS:    'Cертификат выпущен', 
            CERTIFICATES_UPDATE:            'Перевыпуск сертификата', 
            CERTIFICATES_UPDATE_SUCCESS:    'Сертификат перевыпущен', 
            CERTIFICATES_DELETE:            'Удаление сертификата', 
            CERTIFICATES_DELETE_DESCR:      'Этот серификат будет удалён без возможности восстановления. Вы уверены, что хотите сделать это?', 
            CERTIFICATES_DELETE_SUCCESS:    'Сертификат удалён', 
            CERTIFICATES_CHANGE_WARN:       'ВНИМАНИЕ! При создании нового сертификата старый будет удалён!',
            CERTIFICATES_DATE_START:        'Дата начала', 
            CERTIFICATES_DATE_STOP:         'Дата окончания', 
            CERTIFICATES_IMEI:              'IMEI', 
            CERTIFICATES_INFO:              'Описание сертификата', 
            CERTIFICATES_DOWNLOAD_CRT:      'Скачать CRT',
            CERTIFICATES_DOWNLOAD_KEY:      'Скачать KEY',

            SEARCH:                     'Поиск', 

            MENU_AUTH:                  'Авторизация',
            MENU_REGISTRATION:          'Регистрация',
            MENU_FORGOT:                'Забыл пароль',
            MENU_MAIN:                  'Главная', 
            MENU_CARS:                  'Автомобили', 
            MENU_CAR:                   'Автомобиль', 
            MENU_CAR_INFO:              'Информация',
            MENU_CAR_DIAG:              'Диагностика',
            MENU_CAR_ECU:               'Электронный блок',
            MENU_CAR_GNSS:              'GNSS', 
            MENU_CAR_MAP:               'Карта',
            MENU_CAR_AREAS:             'Геозоны',
            MENU_CAR_STATES:            'Состояние', 
            MENU_CAR_RIGHTS:            'Права', 
            MENU_CAR_EVENTS:            'События', 
            MENU_CAR_EVENT:             'Событие', 
            MENU_CAR_EVENT_DATE:        'Дата', 
            MENU_CAR_HISTORY:           'История', 
            MENU_CAR_TRIPS:             'Поездки',
            MENU_DRIVERS:               'Водители', 
            MENU_DRIVER:                'Водитель', 
            MENU_USER_CREATE:           'Создание пользователя', 
            MENU_USER_INFO:             'Информация', 
            MENU_USER_CARS:             'Автомобили', 
            MENU_USER_LOGS:             'Логи', 
            MENU_USER_PASS:             'Пароль', 
            MENU_PROFILE:               'Профиль', 
            MENU_CARS_GROUPS:           'Группы автомобилей', 
            MENU_CARS_GROUP:            'Группа автомобилей', 
            MENU_CARS_GROUP_INFO:       'Информация', 
            MENU_CARS_GROUP_CARS:       'Автомобили',
            MENU_CARS_GROUP_USERS_GROUPS: 'Группы пользователей', 
            MENU_USERS:                 'Пользователи',
            MENU_USERS_GROUPS:          'Группы пользователей', 
            MENU_USERS_GROUP:           'Группа пользователей', 
            MENU_USERS_GROUP_USERS:     'Водители', 
            MENU_USERS_GROUP_CARS:      'Автомобили', 
            MENU_USERS_GROUP_CARS_GROUPS: 'Группы автомобилей',
            MENU_FIRMWARES:             'Прошивки',
            MENU_FIRMWARE:              'Прошивка',

            SMART_CAPTCHA_POLICY:       'Мы используем', 
            SMART_CAPTCHA_ERROR_LOAD:   'Ошибка отправки captcha',
            SMART_CAPTCHA_ERROR_JS:     'Ошибка при попытке проверки сaptcha',
            SMART_CAPTCHA_ERROR_NETWORK:'Ошибка загрузки captcha',
            SMART_CAPTCHA_ERROR_METHOD: 'Метод window.smartCaptcha не найден',

            AUTH:                       'Авторизация', 
            AUTH_LOGIN:                 'Логин',
            AUTH_PASS:                  'Пароль', 
            AUTH_AGREE:                 'Пользовательское соглашение', 
            AUTH_CAPTCHA:               'Проверочный код', 
            AUTH_SUBMIT:                'Войти', 
            AUTH_REGISTRATION:          'Регистрация', 
            AUTH_FORGOT:                'Забыл пароль', 

            REGISTRATION:               'Регистрация', 
            REGISTRATION_LINK:          'Регистрация', 
            REGISTRATION_LOGIN:         'E-mail', 
            REGISTRATION_NAME:          'Имя', 
            REGISTRATION_LASTNAME:      'Фамилия', 
            REGISTRATION_SURNAME:       'Отчество', 
            REGISTRATION_PHONE:         'Телефон', 
            REGISTRATION_PASS:          'Пароль', 
            REGISTRATION_CAPTCHA:       'Проверочный код', 
            REGISTRATION_AGREE:         'Согласие с лицензионным договором', 
            REGISTRATION_SUBMIT:        'Регистрация', 
            REGISTRATION_SUCCESS:       'На указанный Вами e-mail будет отправлена ссылка для активации учётной записи', 
            REGISTRATION_AUTH:          'Авторизация', 
            REGISTRATION_ERROR_FIELDS:  'Проверьте правильность заполнения формы', 
            REGISTRATION_VERIFIED:      'Учётная запись успешно активирована. Теперь Вы можете войти используя указанные при регистрации e-mail и пароль.',

            FORGOT_EMAIL:               'E-mail', 
            FORGOT_CODE:                'Код из e-mail', 
            FORGOT_CODE_DESCR:          'Письмо с проверочным кодом было отправлено на указанный Вами адрес E-mail. Введите код из письма в поле ниже.', 
            FORGOT_LOGIN:               'Войти', 

            PROFILE_LOGOUT:             'Выйти',

            CARS_TITLE:                 'Автомобили', 
            CARS_ONLINE:                'Статус', 
            CARS_FILTER_ONLINE:         'Только на связи', 
            CARS_VIN:                   'VIN',
            CARS_VIN_EMPTY:             'VIN не указан', 
            CARS_NUMBER:                'Гос.номер', 
            CARS_MODEL:                 'Модель', 
            CARS_NAMI_NUMBER:           'Код производителя', 
            CARS_IMEI:                  'IMEI', 
            CARS_READMORE:              'Подробнее', 
            CARS_SEARCH_MODE_ALL:       'Все',
            CARS_SEARCH_MODE_VIN:       'VIN',
            CARS_SEARCH_MODE_TID:       'id GNSS',
            CARS_SEARCH_MODE_IMEI:      'IMEI',
            CARS_SEARCH_MODE_NUMBER:    'Гос.номер',
            CARS_SEARCH_MODE_NAMI:      'Код произв-ля',
            CARS_SEARCH_MODE_PHONE:     'Номер телефона', 
            CARS_SEARCH_MODE_ICCID:     'ICCID', 
            CARS_NAME:                  'Название', 
            CARS_EMPTY:                 'Автомобили не найдены', 

            CARS_CREATE_HEADER:         'Создать автомобиль', 
            CARS_ADD_HEADER:            'Добавить автомобиль', 
            CARS_CREATE_VIN:            'VIN', 
            CARS_CREATE_NUMBER:         'Гос.номер', 
            CARS_CREATE_IMEI:           'IMEI', 
            CARS_CREATE_ICCID:          'Код активации', 
            CARS_CREATE_NAMI_NUMBER:    'Код производителя', 
            CARS_CREATE_TID:            'ID GNSS', 
            CARS_CREATE_NAME:           'Название', 
            CARS_CREATE_PHONE:          'Телефон', 
            CARS_CREATE_STATE:          'Описание', 
            CARS_CREATE_COLOR:          'Цвет', 
            CARS_CREATE_CAPTCHA:        'Проверочный код', 

            CARS_DELETE:                'Удаление автомобиля', 
            CARS_DELETE_DESCR:          'Этот автомобиль будет удалён без возможности восстановления. Вы уверены, что хотите сделать это?', 
            CARS_DELETE_SUCCESS:        'Автомобиль удалён', 

            // Цвета кузовов
            CAR_COLOR_BLACK_COPPER:     "Черная медь",
            CAR_COLOR_BLUE_MAGIC:       "Яркий голубой",
            CAR_COLOR_DEEP_FOREST:      "Темно-зеленый",
            CAR_COLOR_DESERT_RED:       "Красная пустыня",
            CAR_COLOR_DESERT_TAUPE:     "Серо-коричневый",
            CAR_COLOR_GALANT_GREY:      "Темно-серый",
            CAR_COLOR_GRAPHITE_TRACE:   "Графитовый",
            CAR_COLOR_LATTE_MACCHIATO:  "Кофейный",
            CAR_COLOR_LUSTRE_WHITE:     "Белый перламутр",
            CAR_COLOR_NOT_SET:          "Не установлен",
            CAR_COLOR_PORCELAIN:        "Светло-серый солид",
            CAR_COLOR_PULSAR_BLUE:      "Темно-синий",
            CAR_COLOR_RUSSIAN_GOLD:     "Русское золото",
            CAR_COLOR_SHADE_OF_NIGHT:   "Тень ночи",
            CAR_COLOR_SILVER_LINING:    "Стальной голубой",
            CAR_COLOR_SUNSET_GOLD:      "Золотистый",
            CAR_COLOR_UNIVERSE_BLACK:   "Чёрный",
            CAR_COLOR_VELVET_RUBY:      "Рубиновый",

            CAR_RIGHTS:                 'Права и доступ', 
            CAR_RIGHTS_USERS_GROUPS:    'Группы пользователей', 
            CAR_RIGHTS_USERS_GROUPS_NAME: 'Имя', 
            CAR_RIGHTS_USERS_GROUPS_DESCR: 'Описание', 
            CAR_RIGHTS_USERS_GROUPS_CREATE: 'Добавить группу пользователей', 
            CAR_RIGHTS_USERS_GROUPS_CREATE_SUCCESS: 'Группа пользователей добавлена', 
            CAR_RIGHTS_USERS_GROUPS_UPDATE_SUCCESS: 'Группы пользователей автомобиля обновлены', 
            CAR_RIGHTS_USERS_GROUPS_DELETE: 'Удалить группу пользователей', 
            CAR_RIGHTS_USERS_GROUPS_DELETE_DESCR: 'Эта группа пользователей утратит доступ к автомобилю. Вы уверены, что хотите сделать это?',
            CAR_RIGHTS_USERS_GROUPS_DELETE_SUCCESS: 'Группа пользователей потеряла доступ к автомобилю',

            CAR_ECUS:                   'Диагностика', 
            CAR_ECUS_REFRESH:           'Обновить отчёты', 
            CAR_ECUS_REPORTS_DELETE:    'Удалить отчёты', 
            CAR_ECUS_EXPORT:            'Экспорт', 
            CAR_ECUS_ADDITIONAL:        'Дополнительная инфорация', 

            CAR_USERS:                  'Пользователи автомобиля', 
            CAR_USERS_CREATE:           'Добавить пользователей автомобиля', 
            CAR_USERS_CREATE_SUCCESS:   'Пользователь добавлен', 
            CAR_USERS_UPDATE_SUCCESS:   'Пользователь автомобиля обновлён', 
            CAR_USERS_DELETE:           'Удалить пользователя автомобиля', 
            CAR_USERS_DELETE_DESCR:     'Выбранный пользователь утратит доступ к этому автомобилю. Вы уверены, что хотите сделать это?', 
            CAR_USERS_DELETE_SUCCESS:   'Пользователь удалён', 

            CAR_USERS_GROUPS_EMPTY:     'Группы пользователей не найдены', 

            CAR_GROUPS:                 'Группы автомобиля', 
            CAR_GROUPS_EMPTY:           'Группы автомобиля не найдены', 
            CAR_GROUPS_CREATE:          'Добавить группу автомобилей', 
            CAR_GROUPS_CREATE_SUCCESS:  'Автомобиль добавлен в группу', 
            CAR_GROUPS_DELETE:          'Удаление автомобиля из группы', 
            CAR_GROUPS_DELETE_DESCR:    'Автомобиль будет исключён из выбранной группы. Вы уверены, что хотите сделать это? ', 
            CAR_GROUPS_DELETE_SUCCESS:  'Автомобиль исключён из группы', 

            CAR_EVENTS:                 'События', 
            CAR_EVENTS_START:           'Начало', 
            CAR_EVENTS_END:             'Конец', 
            CAR_EVENTS_FILTER:          'Фильтр', 
            CAR_EVENTS_EVENT:           'Событие', 
            CAR_EVENTS_DATE:            'Дата, время', 
            CAR_EVENTS_MAP:             'Карта',
            CAR_EVENTS_ERROR_MAX_PERIOD:'Максимальный период запроса событий - 31 день',
            CAR_EVENTS_ERROR_INVALID_LIMITS: 'Время начала отчётов должно быть меньше, чем время конца',
            CAR_EVENTS_ERROR_NO_LIMITS: 'Укажите время начала и конца отчётов', 

            EVENTS_SUBS:                'Подписка на события',
            EVENTS_SUBS_DESCR:          'Вы можете подписаться на события этого автомобиля. Если они будут происходить, вы получите об этом уведомление на адрес электронной почты, указанный в вашем профиле.',
            EVENTS_SUBS_CREATE_SUCCESS: 'Подписка на событие добавлена',
            EVENTS_SUBS_DELETE_SUCCESS: 'Подписка на событие удалена',

            CAR_STATUS_ONLINE:          'В сети', 
            CAR_STATUS_OFFLINE:         'Нет связи', 

            CAR_STATES:                 'Состояние', 

            CAR_MAP_EVENTS:               'События',
            CAR_MAP_EVENT_SECURE:         'Охрана',
            CAR_MAP_EVENT_SECURE_ADD:     'Постановка/снятие',
            CAR_MAP_EVENT_ENGINE:         'Двигатель',
            CAR_MAP_EVENT_ENGINE_ADD:     'Включение/выключение',
            CAR_MAP_EVENT_TRUNK:          'Багажник',
            CAR_MAP_EVENT_TRUNK_ADD:      'Открытие/закрытие',
            CAR_MAP_EVENT_ZONE:           'Охранная зона',
            CAR_MAP_EVENT_ZONE_ADD:       'Вход/выход',
            CAR_MAP_EVENT_LIGHT:          'Освещение и сигнал',
            CAR_MAP_EVENT_MILEAGE:        'Уменьшение пробега',
            CAR_MAP_EVENT_VOLTAGE:        'Низкий заряд АКБ',
                        
            CAR_TRIP:                     'Поездка',
            CAR_TRIPS:                    'Поездки',
            CAR_TRIPS_ACCELERATION:       'Ускорений', 
            CAR_TRIPS_BRAKING:            'Торможений', 
            CAR_TRIPS_FUELCONSUMPTION:    'Расход топлива', 
            CAR_TRIPS_MILEAGE:            'Пробег', 
            CAR_TRIPS_STARTEDAT:          'Начало', 
            CAR_TRIPS_ENDEDAT:            'Конец', 
            CAR_TRIPS_TIME:               'Длительность',
            CAR_TRIPS_DRIVING_ASSESSMENT: 'Манера вождения', 
            CAR_TRIPS_WITH_MILEAGE:       'Только с пробегом', 

            // Типы кузовов
            CARTYPE_SEDAN:                   'Седан',
            CARTYPE_SEDAN_ARMORED:           'Седан бронированный',
            CARTYPE_LIMO_ARMORED_V12:        'Лимузин бронированный',
            CARTYPE_LIMO_ARMORED_V8:         'Лимузин бронированный',
            CARTYPE_LIMO_ARMORED_V8_CIVIL:   'Лимузин бронированный (гражд.)',
            CARTYPE_CABRIO:                  'Кабриолет',
            CARTYPE_CABRIO_SHOW:             'Кабриолет show',
            CARTYPE_SEDAN_4X2:               'Седан 4x2',
            CARTYPE_SEDAN_LONG:              'Седан удлинённый',
            CARTYPE_SEDAN_LONG_ARMORED:      'Седан удлинённый бронированный',
            CARTYPE_SUV:                     'SUV',
            CARTYPE_SUV_ARMORED:             'SUV бронированный',
            CARTYPE_MPV_4_SEATS:             'MPV 4-х местный',
            CARTYPE_MPV_ARMORED_4_SEATS:     'MPV бронированный 4-х местный',
            CARTYPE_MPV_ARMORED_8_SEATS:     'MPV бронированный 8-и местный',
            CARTYPE_MPV_9_SEATS:             'MPV 9-и местный',
            CARTYPE_MPV_ARMORED_9_SEATS:     'MPV бронированный 9-и местный',
            CARTYPE_MPV_ORBITA:              'MPV Орбита',
            CARTYPE_MPV_TABLETKA:            'MPV Таблетка',
            CARTYPE_RESERVED:                'Резерв',
            CARTYPE_UNKNOWN:                 'Неизвестный кузов',

            FAVORITE_CARS_CREATE_SUCCESS:   'Автомобиль успешно добавлен в избранное', 
            FAVORITE_CARS_DELETE_SUCCESS:   'Автомобиль успешно удалён из избранных', 

            // Типы подвесок
            SUSPENSION_CONVENTIONAL:    'Обычная',
            SUSPENSION_AIR:             'Пневматическая',
            SUSPENSION_DUAL_AIR:        'Пневматическая (двойной контур)',

            CARINFO_HEADER:             'Информация', 
            CARINFO_BODY_TYPE:          'Кузов', 
            CARINFO_ENGINE:             'Двигатель', 
            CARINFO_MANUFACTORER:       'Производитель', 
            CARINFO_COLOR:              'Цвет', 
            CARINFO_VIN:                'VIN',
            CARINFO_VIN_UPDATE:         'Обновление VIN', 
            CARINFO_ICCID:              'ICC ID', 
            CARINFO_EICCID:             'ERA ICC ID', 
            CARINFO_NAMI_NUMBER:        'Код производителя', 
            CARINFO_NAME:               'Название', 
            CARINFO_SUSPENSION:         'Подвеска', 
            CARINFO_CAR_NUMBER:         'Гос.номер', 
            CARINFO_STATE:              'Описание', 
            CARINFO_TID:                'ID GNSS', 
            CARINFO_IMEI:               'IMEI', 
            CARINFO_PHONE:              'Телефон GNSS', 
            CARINFO_PLATFORM:           'Платформа', 
            CARINFO_UUID:               'UUID', 
            CARINFO_MODEL:              'Модель', 
            CARINFO_YEAR:               'Модельный год', 
            CARINFO_TELEMATIC:          'Всегда подключён', 
            CARINFO_CREATED:            'Создан', 
            CARINFO_UPDATE_SUCCESS:     'Информация об автомобиле успешно обновлена', 

            CARMAP_TRACK_TITLE:         'История поездок', 
            CARMAP_TRACK_START:         'Начало поездки', 
            CARMAP_TRACK_FINISH:        'Конец поездки', 
            CARMAP_TRACK_TODAY:         'Сегодня', 
            CARMAP_TRACK_YESTERDAY:     'Вчера', 
            CARMAP_TRACK_WEEK:          'За неделю', 
            CARMAP_CRASH:               'Не удалось загрузить карты. Попробуйте обновить страницу (Ctrl+F5) или зайти позже. Если ошибка будет повторяться - свяжитесь с администратором!', 
            CARMAP_SPEED:               'Скорость', 
            CARMAP_UPDATE_DATE:         'Обновлено', 

            USERS:                      'Водители', 
            USERS_EMPTY:                'Водители не найдены', 
            USERS_CREATE_HEADER:        'Добавить водителя', 
            USERS_SEARCH_MODE_ALL:      'Все', 
            USERS_SEARCH_MODE_EMAIL:    'E-mail', 
            USERS_SEARCH_MODE_PHONE:    'Телефон', 
            USERS_SEARCH_MODE_NAME:     'Имя', 
            USERS_SEARCH_MODE_MIDNAME:  'Фамилия', 
            USERS_SEARCH_MODE_SURNAME:  'Отчество', 
            USERS_NEW_USER:             'Новый пользователь',
            USERS_READMORE:             'Подробнее', 
            USERS_DELETE:               'Удалить пользователя', 
            USERS_DELETE_DESCR:         'Этот пользователь будет удалён без возможности восстановления. Вы уверены. что хотите сделать это?', 
            USERS_DELETE_SUCCESS:       'Выбранный пользователь удалён', 

            USER_INFO:                  'Информация', 
            USER_NAME:                  'Имя', 
            USER_SURNAME:               'Отчество', 
            USER_LASTNAME:              'Фамилия', 
            USER_EMAIL:                 'E-mail', 
            USER_PHONE:                 'Телефон', 
            USER_CODE:                  'Проверочный код', 
            USER_GROUP:                 'Группа', 
            USER_LOGS:                  'Действия пользователя',
            USER_LOGS_DATE:             'Дата, время', 
            USER_LOGS_ACTION:           'Действие', 
            USER_LOGS_LEVEL:            'Уровень',
            USER_LOGS_DETAILS:          'Подробности', 
            USER_PASS:                  'Пароль', 
            USER_PASS_REPEAT:           'Повторите пароль', 
            USER_UPDATE_SUCCESS:        'Информация о пользователе обновлена', 
            USER_ATTR_WARNING:          'При изменении группы или атрибутов пользователя все его сессии будут удалены. Ему будет необходимо повторно пройти авторизацию на всех устройствах.', 
            USER_GROUP_EMPTY:           'Нет группы',
            USER_GROUPS:                'Группы пользователей', 
            USER_STATUS_LOCK:           'Заблокировать пользователя', 
            USER_STATUS_ACTIVE:         'Пользователь активен',
            USER_STATUS_LOCKED:         'Пользователь заблокирован',
            USER_UPDATED:               'Обновлён', 
            USER_CARS:                  'Автомобили пользователя', 
            USER_CARS_CREATE:           'Добавить автомобили',
            USER_CARS_CREATE_SUCCESS:   'Автомобиль успешно добавлен пользователю', 
            USER_CARS_DELETE:           'Удалить автомобиль', 
            USER_CARS_DELETE_DESCR:     'Пользователь утратит доступ к этому автомобилю. Вы уверены, что хотите сделать это?', 
            USER_CARS_DELETE_SUCCESS:   'Пользователь утратил доступ к выбранному автомобилю', 

            // Создание пользователя
            USER_CREATE_NAME:           'Имя',
            USER_CREATE_MID_NAME:       'Отчество', 
            USER_CREATE_LAST_NAME:      'Фамилия', 
            USER_CREATE_ATTR:           'Атрибуты',
            USER_CREATE_TYPE:           'Тип', 
            USER_CREATE_GROUP:          'Группа',
            USER_CREATE_GROUP_EMPTY:    'Нет группы',
            USER_CREATE_GROUP_NEW:      'Новая группа',
            USER_CREATE_GROUP_NEW_NAME: 'Название', 
            USER_CREATE_GROUP_NEW_DESCR:'Описание', 
            USER_CREATE_EMAIL:          'E-mail',
            USER_CREATE_PHONE:          'Телефон',
            USER_CREATE_PASS:           'Пароль', 
            USER_CREATE_PASS_REPEAT:    'Повторите пароль',
            USER_CREATE_PASS_DESCR:     'Минимум 8 символов, одна строчная буква, одна заглавная буква, одна цифра и один символ _-%&',

            // Типы пользователей
            USER_TYPE:                  'Тип пользователя',
            USER_TYPE_USER:             'Пользователь',
            USER_TYPE_EXPERT:           'Эксперт',
            USER_TYPE_SUPER:            'Администратор',
            USER_TYPE_SUPER_DESCR:      'ВНИМАНИЕ! Этот пользователь получит полный контроль над приложением.',

            CARS_GROUPS:                'Группы автомобилей', 
            CARS_GROUPS_CREATE:         'Создать группу автомобилей', 
            CARS_GROUPS_CREATE_NAME:    'Название', 
            CARS_GROUPS_CREATE_DESCR:   'Описание', 
            CARS_GROUPS_CREATE_SUCCESS: 'Группа автомобилей успешно создана', 
            CARS_GROUPS_DELETE:         'Удалить группу автомобилей', 
            CARS_GROUPS_DELETE_DESCR:   'Эта группа автомобилей будет удалена без возможности восстановления. Вы уверены, что хотите сделать это?', 
            CARS_GROUPS_DELETE_SUCCESS: 'Группа автомобилей успешно удалена', 

            CARS_GROUP:                 'Группа автоморбилей', 
            CARS_GROUP_INFO:            'Информация о группе', 
            CARS_GROUP_UPDATE_SUCCESS:  'Информация о группе автомобилей обновлена', 
            CARS_GROUP_USERS_GROUPS:    'Группы пользователей', 
            CARS_GROUP_USERS_GROUPS_CREATE: 'Добавить группу пользователей', 
            CARS_GROUP_USERS_GROUPS_CREATE_SUCCESS: 'Группа пользователей добавлена', 
            CARS_GROUP_USERS_GROUPS_UPDATE_SUCCESS: 'Группа пользователей обновлена', 
            CARS_GROUP_USERS_GROUPS_DELETE: 'Удалить группу пользователей', 
            CARS_GROUP_USERS_GROUPS_DELETE_DESCR: 'Группа пользователей утратит доступ к этому автомобилю. Вы уверены, что хотите сделать это? ', 
            CARS_GROUP_USERS_GROUPS_DELETE_SUCCESS: 'Группа удалена', 

            CARS_GROUPS_NAME:           'Название', 
            CARS_GROUPS_DESCR:          'Описание', 

            CARS_GROUP_CARS:            'Автомобили группы', 
            CARS_GROUP_CARS_EMPTY:      'Автомобили группы не найдены', 
            CARS_GROUP_CARS_CREATE:     'Добавить автомобиль',
            CARS_GROUP_CARS_CREATE_SUCCESS: 'Автомобиль добавлен в группу', 
            CARS_GROUP_CARS_DELETE_HEADER: 'Удаление автомобиля', 
            CARS_GROUP_CARS_DELETE_DESCR: 'Этот автомобиль будет удалён из группы без возможности восстановления. Вы уверены, что хотите сделать это?', 
            CARS_GROUP_CARS_DELETE_SUCCESS: 'Автомобиль удалён из группы', 

            USERS_GROUPS:               'Группы пользователей', 
            USERS_GROUPS_NAME:          'Название',
            USERS_GROUPS_DESCR:         'Описание', 
            USERS_GROUPS_CREATE:        'Создать группу пользователей', 
            USERS_GROUPS_CREATE_NAME:   'Название', 
            USERS_GROUPS_CREATE_DESCR:  'Описание', 
            USERS_GROUPS_UPDATE_SUCCESS:'Группа пользователей успешно обновлена', 
            USERS_GROUPS_CREATE_SUCCESS:'Группа пользователей успешно создана', 
            USERS_GROUPS_DELETE:        'Удалить группу пользователей', 
            USERS_GROUPS_DELETE_DESCR:  'Эта группа пользователей будет удалена без возможности восстановления. Вы уверены, что хотите сделать это?', 
            USERS_GROUPS_DELETE_SUCCESS:'Группа пользователей успешно удалена', 

            USERS_GROUP_INFO:           'Информация', 
            USERS_GROUP_DRIVERS:        'Водители', 
            USERS_GROUP_CARS:           'Автомобили', 
            USERS_GROUP_CARS_GROUPS:    'Группы автомобилей',
            USERS_GROUP_CARS_GROUPS_EMPTY: 'Группы автомобилей не найдены', 
            USERS_GROUP_CARS_GROUPS_CREATE: 'Добавить группу автомобилей', 
            USERS_GROUP_CARS_GROUPS_CREATE_SUCCESS: 'Группа автомобилей успешно добавлена', 
            USERS_GROUP_CARS_GROUPS_UPDATE_SUCCESS: 'Атрибуты группы автомобилей обновлены',
            USERS_GROUP_CARS_GROUPS_DELETE: 'Отвязать группу автомобилей', 
            USERS_GROUP_CARS_GROUPS_DELETE_DESCR: 'Эта группы пользователей утратит доступ к выбранной группе автомобилей. Вы уверены, что хотите сделать это?', 
            USERS_GROUP_CARS_GROUPS_DELETE_SUCCESS: 'Группа автомобилей отвязана от группы пользователей', 
            USERS_GROUP_USERS_NAME:     'Имя', 
            USERS_GROUP_USERS_EMAIL:    'E-mail', 
            USERS_GROUP_USERS_CREATE:   'Добавить пользователя группы',
            USERS_GROUP_USERS_CREATE_SUCCESS: 'Пользователь успешно добавлен в группу', 
            USERS_GROUP_USERS_DELETE:   'Удалить пользователя', 
            USERS_GROUP_USERS_DELETE_DESCR: 'Пользователь будет удалён из выбранной группы. Вы уверены, что хотите сделать это?', 
            USERS_GROUP_USERS_DELETE_SUCCESS: 'Пользователь успешно удалён из группы', 

            EVENT_VIN:                  'VIN',
            EVENT_TYPE:                 'Событие',
            EVENT_SEARCH:               'Поиск событий',
            EVENT_DATE:                 'Дата',
            EVENT_MAP:                  'На карте',
            EVENT_COORDS:               'Координаты',
            EVENT_GOTO_CAR:             'Перейти к автомобилю',
            EVENT_ALL:                  'Все',
            EVENT_ENGINE_ON:            'Включение двигателя',
            EVENT_REMOTE_ENGINE_ON:     'Удаленное включение двигателя',
            EVENT_ENGINE_OFF:           'Выключение двигателя',
            EVENT_DECREASE_MILEAGE:     'Уменьшение общего пробега',
            EVENT_PROTECTED_AREA_IN:    'Вход в охранную зону',
            EVENT_PROTECTED_AREA:       'Выход из охранной зоны',
            EVENT_UNLOCKED:             'Снятие автомобиля с охраны',
            EVENT_LOCKED:               'Постановка автомобиля под охрану',
            EVENT_CMD_ENGINE_ON:        'Отправлена команда на запуск двигателя',
            EVENT_CMD_ENGINE_OFF:       'Отправлена команда на остановку двигателя',
            EVENT_CMD_UNLOCK:           'Отправлена команда на снятие с охраны',
            EVENT_CMD_LOCK:             'Отправлена команда на постановку под охрану',
            EVENT_CMD_TRUNK_OPEN:       'Отправлена команда на открытие багажника',
            EVENT_CMD_TRUNK_CLOSE:      'Отправлена команда на закрытие багажника',
            EVENT_CMD_LIGHT:            'Отправлена команда мигнуть фарами',
            EVENT_CMD_BEEP:             'Отправлена команда подать звуковой сигнал',
            EVENT_LOW_BATTERY_VOLTAGE:  'Низкий заряд аккумулятора',
            EVENT_ALARM_SYSTEM_TRIGGERED:'Срабатывание штатной сигнализации',
            EVENT_NOT_SET:               'Не задано',

            // UTACarMapList
            EVENTS_TRIP_TRACKS:         'Треки поездок',

            ECU_EXPORT:                 'Экспорт отчёта',
            ECU_REFRESH:                'Обновить отчёты',
            ECU_INFO:                   'Информация',
            ECU_ERRORS:                 'Ошибки',
            ECU_ERRORS_ONLY_ACTIVE:     'Только активные',
            ECU_REPORTS:                'Отчёты',
            ECU_REPORTS_DISABLED:       'Графики онлайн / Онлайн-телеметрия: разработка приостановлена',
            ECU_SERIAL:                 'Серийный номер',
            ECU_HARDWARE:               'Аппаратная версия',
            ECU_FIRMWARE:               'Версия ПО',
            ECU_VIN:                    'VIN по ЭБУ',
            ECU_CALIBRATION:            'Калибровка',
            ECU_MILEAGE:                'Пробег',
            ECU_SOFTWARE:               'Прошивка',
            ECU_TIMESTAMP:              'Время последней диагностики',
            ECU_ERRORS_EMPTY:           'Ошибок не обнаружено',
            ECU_HISTORY:                'История отчетов',
            ECU_FILE:                   'Файлы',
            ECU_DATE:                   'Дата, время', 
            ECU_REMOVE:                 'Удалить',
            ECU_PARAMS:                 'Параметры',
            ECU_PARAMS_DESCR:           'Установите чекбокс в поле Data, чтобы отправить число в шестнадцатеричном формате. При запросе статуса параметров поле "Data" с жёлтым фоном означает, что параметр создан, но не отправлен в блок GNSS. Поле "Data" с зелёным контуром и галочкой означает получение параметра блоком GNSS.', 
            ECU_PARAMS_NO_INFO:         'Нет информации о параметрах блока',
            ECU_PARAMS_EMPTY:           'Параметры блока не установлены. Создайте их через форму отправки команд.', 
            ECU_PARAM_CREATE_SUCCESS:   'Новый параметр успешно добавлен', 
            ECU_PARAM_UPDATE:           'Обновление параметра', 
            ECU_PARAM_UPDATE_SUCCESS:   'Параметр успешно обновлён', 
            ECU_PARAM_DELETE:           'Удаление параметра', 
            ECU_PARAM_DELETE_TEXT:      'Этот параметр будет удалён без возможности восстановления. Вы уверены, что хотите удалить его?', 
            ECU_PARAM_DELETE_SUCCESS:   'Параметр успешно удалён из блока', 

            ECU_GNSS_REFRESH:           'Обновить отчёты',
            ECU_GNSS_REBOOT:            'Перезагрузить GNSS',
            ECU_GNSS_FIRMWARES:         'Прошивки',
            ECU_GNSS_FIRMWARES_DELETE:  'Удалить файл прошивки',
            ECU_GNSS_FIRMWARES_DELETE_DESCR: 'Этот файл прошивки будет удалён без возможности восстановления. Вы уверены, что хотите сделать это?',
            ECU_GNSS_FIRMWARES_DELETE_SUCCESS: 'Файл прошивки успешно удалён',
            ECU_GNSS_LOGS:              'Журнал',
            ECU_GNSS_LOGS_GEO:          'Гео-данные', 
            // ECU_GNSS_UPDATE_DIAG:       'Обновление Diag-CAN',
            ECU_GNSS_DESCR:             'Описание',
            ECU_GNSS_SOFTWARE:          'Версия ПО',
            ECU_GNSS_UPDATE_NAVI:       'Обновление навигации',
            ECU_GNSS_MANUFACTORER:      'Код производителя',
            ECU_GNSS_CREATE_DATE:       'Аппаратная версия',
            ECU_GNSS_UPDATE_PARAMS:     'Обновление CAN',
            ECU_GNSS_MODIFICATION:      'Модификация',
            ECU_GNSS_TID:               'id GNSS',
            ECU_GNSS_SET_SERVER:        'Установить сервер данных',
            ECU_GNSS_DEBUG_PARAMS:      'Отладочные параметры', 
            ECU_GNSS_TELEMATIC:         'Управление режимом работы',
            ECU_GNSS_TELEMATIC_ON:      'Включить телематику',
            ECU_GNSS_TELEMATIC_OFF:     'Выключить телематику',
            ECU_GNSS_SEND_CMD:          'Отправить команду',
            ECU_GNSS_ONLINE_DATE:       'Время последнего выхода на связь',
            ECU_GNSS_SET_PARAMS_TITLE:  'Параметры [установка / проверка]',
            ECU_GNSS_CMD:               'Команды',
            ECU_GNSS_CMD_TITLE:         'Отправка команд [параметры]',
            ECU_MODULES_INFO:           'Модули', 
            ECU_MODULES_MAIN:           'Основной модуль', 
            ECU_MODULES_INTERFACE:      'Интерфейсный модуль', 
            ECU_MODULES_BOOTLOADER:     'Загрузчик',
            ECU_MODULES_INFO_EMPTY:     'Нет информации о модулях устройства', 

            CMD_RESULT_NOT_SET:             'Статус не установлен',
            CMD_RESULT_SEND_IN_PROCESS:     'Команда отправлена на автомобиль',
            CMD_RESULT_SEND_TIMEOUT:        'Время подтверждения получения команды от автомобиля, превысило время ожидания',
            CMD_RESULT_SEND_CONFIRMED:      'Получено подтверждение получения команды от автомобиля',
            CMD_RESULT_RESULT_OK:           'Автомобиль прислал результат выполнения команды: успешное выполнение',
            CMD_RESULT_RESULT_ERROR:        'Автомобиль прислал результат выполнения команды: ошибка',
            CMD_RESULT_RESULT_ILL:          'Автомобиль прислал результат выполнения команды: ошибка, отсутствие в списке разрешённых команд',
            CMD_RESULT_RESULT_DEL:          'Автомобиль прислал результат выполнения команды: успешно удалена',
            CMD_RESULT_RESULT_NOT_FOUND:    'Автомобиль прислал результат выполнения команды: команда для удаления не найдена',
            CMD_RESULT_RESULT_NOT_CONFIG:   'Автомобиль прислал результат выполнения команды: успешное выполнение, отрицательный ответ',
            CMD_RESULT_RESULT_IN_PROCESS:   'Автомобиль прислал результат выполнения команды: команда передана на обработку',
            CMD_SUCCESS:                    'Команда отправлена', 

            ECU_FIRMWARE_UPLOAD:        'Загрузить прошивку',
            ECU_FIRMWARE_FILE:          'Файл',
            ECU_FIRMWARE_FILE_EMPTY:    'Вы пытаетесь загрузить пустой файл', 
            ECU_FIRMWARE_FILE_LARGE:    'Файл прошивки слишком большой (максимум 2 МБ)', 
            ECU_FIRMWARE_FILE_ERROR:    'Не выбран файл прошивки', 
            ECU_FIRMWARE_TYPE:          'Тип',
            ECU_FIRMWARE_TYPE_ALL:      'Универсальная',
            ECU_FIRMWARE_TYPE_ALL_EGTS: 'EGTS',
            ECU_FIRMWARE_TYPE_ALL_RLP:  'RLP',
            ECU_FIRMWARE_STATUS:        'Статус',
            ECU_FIRMWARE_STATUS_OK:     'Успешно загружена', 
            ECU_FIRMWARE_CREATE_SUCCESS:'Файл прошивки успешно загружен на сервер. Дождитесь загрузки на устройство',
            ECU_FIRMWARE_DELETE_SUCCESS:'Файл прошивки успешно удален',

            /**
             * Состояние автомобиля
             * 
             * "STATE_" + имя состояния в верхнем регистре
             */
            STATE_TABS_STATISTICS:              'Последняя поездка',
            STATE_TABS_LAST_TRIP:               'Путевая статистика',
            STATE_TABS_WHEELS:                  'Давление шин',
            STATE_TABS_BRAKES:                  'Тормозная система',
            STATE_TABS_INTERIOR:                'Состояние салона',
            STATE_TABS_TRANSMISSION:            'АКПП',
            STATE_TABS_BATTERY:                 'АКБ',
            STATE_TABS_LIGHT:                   'Освещение',
            STATE_TABS_ENGINE:                  'Двигатель',
            STATE_TABS_DOORS:                   'Двери/кузов',
            STATE_TABS_ELECTRIC:                'АКБ',

            STATE_INTERIOR_CHAIR_FL:            'Переднее левое кресло', 
            STATE_INTERIOR_CHAIR_FR:            'Переднее правое кресло', 
            STATE_INTERIOR_CHAIR_RL:            'Заднее левое кресло', 
            STATE_INTERIOR_CHAIR_RR:            'Заднее правое кресло', 
            STATE_INTERIOR_CHAIR_DESCR:         'Пассажиры в машине', 
            STATE_INTERIOR_CHAIR_LARGE:         'Взрослый', 
            STATE_INTERIOR_CHAIR_SMALL:         'Ребёнок', 
            STATE_INTERIOR_CHAIR_CHILD:         'Детское кресло', 
            STATE_INTERIOR_CHAIR_EMPTY:         'Пусто', 
            STATE_INTERIOR_CHAIR_UNKNOWN:       'Неизвестно', 
            STATE_INTERIOR_CHAIR_ERROR:         'Ошибка', 

            STATE_GROUP_BATTERY_12V:            'Батарея 12В',
            STATE_GROUP_BATTERY_HW:             'Высоковольтная батарея',
            STATE_GROUP_LAST_TRIP:              'Последняя поездка',
            STATE_GROUP_LAST_MONTH:             'Статистика за месяц', 
            STATE_GROUP_AFTER_RESET:            'После сброса',
            STATE_GROUP_LAST_EVENTS:            'Последние события',

            STATE_DMFR_WARNING_INDICATOR:       'Состояние блока двери [передняя правая]', 
            STATE_DMFL_WARNING_INDICATOR:       'Состояние блока двери [передняя левая]', 
            STATE_DMRR_WARNING_INDICATOR:       'Состояние блока двери [задняя правая]', 
            STATE_DMRL_WARNING_INDICATOR:       'Состояние блока двери [задняя левая]', 

            STATE_DOOR_FRONT_RIGHT_CLOSED:      'Замок двери [передний пассажир]', 
            STATE_DOOR_FRONT_LEFT_CLOSED:       'Замок двери [водитель]', 
            STATE_DOOR_BACK_LEFT_CLOSED:        'Замок двери [задний левый пассажир]', 
            STATE_DOOR_BACK_RIGHT_CLOSED:       'Замок двери [задний правый пассажир]', 

            STATE_DOOR_FRONT_RIGHT:             'Дверь переднего пассажира', 
            STATE_DOOR_FRONT_LEFT:              'Дверь водителя', 
            STATE_DOOR_BACK_RIGHT:              'Дверь заднего правого пассажира', 
            STATE_DOOR_BACK_LEFT:               'Дверь заднего левого пассажира', 

            STATE_DOOR_HOOD:                    'Капот', 
            STATE_DOOR_TRUNK:                   'Багажник', 
            STATE_DOOR_TRUNK_DIRECTION:         'Движение крышки багазника', 

            STATE_CORNERING_LIGHT_RIGHT_STATUS: 'Состояние правого блока адаптивного освещения', 
            STATE_CORNERING_LIGHT_LEFT_STATUS:  'Состояние левого блока адаптивного освещения', 

            STATE_T30I_FAULT_STATUS:            'Состояние линии Т30i', 
            STATE_T15_FAULT_STATUS:             'Состояние линии Т15', 
            STATE_T30D_FAULT_STATUS:            'Состояние линии Т30d', 
            STATE_SCU_FAULT_STATUS:             'Состояние подвески',

            STATE_BRAKE_LIGHT_LEFT_STATUS:      'Состояние левого стоп-сигнала', 
            STATE_BRAKE_LIGHT_RIGHT_STATUS:     'Состояние правого стоп-сигнала', 
            STATE_BRAKE_LIGHT_HM_STATUS:        'Состояние дополнительного стоп-сигнала', 

            STATE_WHEEL_FRONT_RIGHT_STATUS:     'Датчик давления шин [передний правый]', 
            STATE_WHEEL_FRONT_LEFT_STATUS:      'Датчик давления шин [передний левый]', 
            STATE_WHEEL_BACK_RIGHT_STATUS:      'Датчик давления шин [передний задний]', 
            STATE_WHEEL_BACK_LEFT_STATUS:       'Датчик давления шин [задний левый]', 

            STATE_WHEEL_PRESSURE_STATUS_HIGH:   'Высокое давление',
            STATE_WHEEL_PRESSURE_STATUS_NORMAL: 'Нормальное давление',
            STATE_WHEEL_PRESSURE_STATUS_LOW:    'Низкое давление',
            STATE_WHEEL_PRESSURE_STATUS_CRITICAL: 'Критически низкое давление!',
            STATE_WHEEL_PRESSURE_STATUS_ERROR:  'Ошибка!',

            STATE_WHEEL_FRONT_RIGHT_PRESSURE:   'Давление шин [передняя правая]', 
            STATE_WHEEL_FRONT_LEFT_PRESSURE:    'Давление шин [передняя левая]', 
            STATE_WHEEL_BACK_RIGHT_PRESSURE:    'Давление шин [задняя правая]', 
            STATE_WHEEL_BACK_LEFT_PRESSURE:     'Давление шин [задняя левая]', 

            STATE_TURN_INDICATOR_FR_STATUS:     'Состояние правого переднего поворотника', 
            STATE_TURN_INDICATOR_FL_STATUS:     'Состояние левого переднего поворотника', 
            STATE_TURN_INDICATOR_MR_STATUS:     'Состояние правого поворотника на зеркале', 
            STATE_TURN_INDICATOR_ML_STATUS:     'Состояние левого поворотника на зеркале',  
            STATE_TURN_INDICATOR_RR_STATUS:     'Состояние правого заднего поворотника', 
            STATE_TURN_INDICATOR_RL_STATUS:     'Состояние левого заднего поворотника', 

            STATE_WINDOW_FULLY_CLOSED_FL:       'Окно [переднее левое]', 
            STATE_WINDOW_FULLY_CLOSED_FR:       'Окно [переднее правое]', 
            STATE_WINDOW_FULLY_CLOSED_RL:       'Окно [заднее левое окно]', 
            STATE_WINDOW_FULLY_CLOSED_RR:       'Окно [заднее правое]', 
            STATE_WINDOW_OPEN:                  'Окно открыто',

            STATE_TPMS_BATTERY_STATUS:          'Состояние батареи датчика давления шины',
            STATE_TPMS_BATTERY_STATUS_FR:       'Состояние батареи датчика давления шины ПП', 
            STATE_TPMS_BATTERY_STATUS_FL:       'Состояние батареи датчика давления шины ПЛ', 
            STATE_TPMS_BATTERY_STATUS_RR:       'Состояние батареи датчика давления шины ЗП',
            STATE_TPMS_BATTERY_STATUS_RL:       'Состояние батареи датчика давления шины ЗЛ',  
            STATE_TPMS_BATTERY_NORMAL:          'Норма',
            STATE_TPMS_BATTERY_LOW:             'Низкий уровень',

            STATE_ENGINE_TIME:                  'Моточасы',

            STATE_FRONT_RIGHT_TEMPERATURE:      'Температура [климат-контроль; передний пассажир]', 
            STATE_FRONT_LEFT_TEMPERATURE:       'Температура [климат-контроль; водитель]', 
            STATE_FRONT_INSIDE_TEMPERATURE:     'Температура [внутри салона; передняя]', 
            STATE_BACK_RIGHT_TEMPERATURE:       'Температура [климат-контроль; задний правый пассажир]', 
            STATE_BACK_LEFT_TEMPERATURE:        'Температура [климат-контроль; задний левый пассажир]', 
            STATE_BACK_INSIDE_TEMPERATURE:      'Температура [внутри салона; задняя]', 

            STATE_TEMPERATURE_OUTSIDE:          'Внешняя температура', 

            STATE_RIDE_AVERAGE_SPEED:           'Ср. скорость за поездку', 
            STATE_OIL_PRESSURE_WARNING:         'Индикатор давления масла в двигателе', 
            STATE_IS_LOCKED:                    'Статус замков дверей', 

            STATE_STATUS: 'Статус автомобиля', 
            STATE_OIL_LEVEL: 'Уровень масла двигателя', 

            STATE_MIL_ONRQ: 'Индикатор ошибки двигателя', 
            STATE_POSITION_LIGHT_FR_STATUS: 'Состояние переднего правого габаритного огня', 
            STATE_HEAD_LIGHT_LEVELING_CTRL_FAILURE: 'Состояние системы автокоррекции фар', 
            STATE_LTC_COOLANT_LVL: 'Уровень охлаждающей жидкости высоковольтной системы', 
            STATE_COOLANT_TEMPERATURE: 'Температура ОЖ', 
            STATE_RECEIVED_SIGNAL_STRENGTH_INDICATOR: 'Показатель уровня принимаемого сигнала', 

            STATE_REVERSE_LIGHT_RIGHT_STATUS: 'Состояние правого сигнала заднего хода', 
            STATE_START_MOVING: 'Время начала движения', 
            STATE_STOP_MOVING: 'Время остановки автомобиля', 
            // STATE_VEHICLE_SECURE_LOCK_STATE: 'Статус блокировки замков', // Стейт удалён на стороне бекенда
            STATE_REAR_FOG_LIGHT_STATUS: 'Состояние задней ПТФ', 
            STATE_ABS_LAMP: 'Состояние АБС', 
            STATE_FRONT_RIGHT_FOG_LIGHT_STATUS: 'Состояние передней правой ПТФ', 
            STATE_POSITION_LIGHT_RR_STATUS: 'Состояние заднего правого габаритного огня', 
            STATE_LOW_BEAM_RIGHT_STATUS: 'Состояние правой фары ближнего света', 
            STATE_EPB_STATUS: 'Ручник', 
            STATE_ESP_LAMP: 'Состояние ESP', 
            STATE_TPMS_SENSOR_FAULT_FR: 'Ошибка датчика давления шины ПП', 
            STATE_TPMS_SENSOR_FAULT_RL: 'Ошибка датчика давления шины ЗЛ', 
            STATE_RIDE_MILEAGE: 'Пробег за поездку', 
            STATE_LAST_NAVIGATION_TIME: 'Последнее обновление навигации', 
            STATE_HV_SYSTEM_FAILURE: 'Высоковольтная система', 
            STATE_FUEL: 'Уровень топлива', 
            STATE_FRONT_LEFT_FOG_LIGHT_STATUS: 'Состояние передней левой ПТФ', 
            STATE_POSITION_LIGHT_RL_STATUS: 'Состояние заднего левого габаритного огня', 
            STATE_BCM_WARNING_INDICATOR: 'Состояние модуля кузовной электроники', 
            STATE_ONLINE: 'В сети', 
            STATE_OFFLINE: 'Не в сети',
            STATE_ENGINE_ON: 'Время запуска двигателя', 
            STATE_DAYTIME_LIGHT_RIGHT_STATUS: 'Состояние правого дневного ходового огня',
            STATE_MOBILE_NETWORK_TYPE_INDICATOR: 'Тип связи', 
            STATE_POSITION_LIGHT_FL_STATUS: 'Состояние переднего левого габаритного огня', 
            STATE_TPMS_SENSOR_FAULT_FL: 'Ошибка датчика давления шины ПЛ', 
            STATE_DAYTIME_LIGHT_LEFT_STATUS: 'Состояние левого дневного ходового огня', 
            STATE_TPMS_SENSOR_FAULT_RR: 'Ошибка датчика давления шины ЗП', 
            STATE_ENGINE_OIL_TEMP: 'Температура [масло в двигателе]', 
            STATE_ENGINE_REV: 'Обороты двигателя', 
            STATE_TCS_LAMP: 'Состояние TCS', 
            STATE_EBD_LAMP: 'Состояние EBD', 
            // STATE_MILEAGE_ON_FUEL_RESIDUES: 'Пробег на остатке топлива', // Старый параметр
            STATE_HIGH_BEAM_LEFT_STATUS: 'Состояние левой фары дальнего света', 
            STATE_ENGINE_TEMPERATURE: 'Температура [охлаждающая жидкость]', 
            STATE_RIDE_TIME: 'Время в пути за поездку', 
            STATE_ENGINE_OFF: 'Время остановки двигателя', 
            STATE_WASHER_FLUID: 'Уровень омывающей жидкости', 
            STATE_WASHER_FLUID_WARNING: 'Низкий уровень омывающей жидкости',
            STATE_TOTAL_MILEAGE: 'Общий пробег', 
            STATE_MIL_IND_BLINK: 'Индикатор критической ошибки двигателя', 
            STATE_COOLANT_FLUID: 'Уровень охлаждающей жидкости', 
            STATE_COOLANT_FLUID_NORMAL: 'Норма',
            STATE_COOLANT_FLUID_LOW: 'Низкий уровень',
            STATE_LOW_BEAM_LEFT_STATUS: 'Состояние левой фары ближнего света', 
            STATE_RIDE_FUEL_CONSUMPTION: 'Расход топлива за поездку', 
            STATE_ENGINE_OIL_LVIND: 'Индикатор уровня масла в двигателе', 
            STATE_HIGH_BEAM_RIGHT_STATUS: 'Состояние правой фары дальнего света', 
            STATE_ESP_SPEED: 'Скорость', 
            STATE_LAST_CAN_PARAM_TIME: 'Последнее обновление параметров автомобиля', // Обновление CAN
            STATE_TM_WARNING_INDICATOR: 'Состояние багажника', 
            STATE_REVERSE_LIGHT_LEFT_STATUS: 'Состояние левого сигнала заднего хода', 
            STATE_SERVICE_DATE: 'Дней до ТО',
            STATE_GEAR_POSITION: 'Положение рычага АКПП',
            STATE_LAST_ONLINE: 'Последний выход на связь',
            STATE_SERVICE_MILEAGE: 'Пробег до ТО',
            STATE_ST_TRANSMISSION_WARNING: 'Состояние АКПП',
            STATE_SCU_CALIBRATION_STATUS: 'Состояние калибровки подвески',
            STATE_CCU_FAILURE: 'Состояние климатической системы',
            STATE_ERAG_FAILURE_STATUS: 'Состояние системы экстренного вызова',
            STATE_OPEN: 'Открыто',
            STATE_HALF_OPEN: 'Открыт наполовину',
            STATE_CLOSED: 'Закрыто',
            STATE_NOT_CLOSED: 'Не закрыто',
            STATE_RESERV: '(резерв)',
            STATE_MILEAGE_WARNING: 'ВНИМАНИЕ! Пробег, записанный в этом электронном блоке существенно отличается от пробега, хранящегося в электронном блоке ESP',
            STATE_SDM_UPTIME: 'Последнее включение/перезапуск', 
            STATE_VAS_ACTIVATION: 'Состояние охранной сигнализации', 
            STATE_LOCK_SECURE: 'На охране',
            STATE_CRUISING_RANGE: 'Пробег на остатке топлива', 

            // ПАРАМЕТРЫ ПОСЛЕ СБРОСА БК
            STATE_TOTAL_MILEAGE_AM:     'Пробег после сброса',
            STATE_TOTAL_AVG_SPEED_AM:   'Ср. скорость после сброса',
            STATE_TOTAL_MINS_AM:        'Время в пути после сброса',
            STATE_FUEL_CONSUMPTION:     'Ср. расход после сброса', 

            // АКБ / БАТАРЕЯ
            STATE_BAT_CAPACITY:     'Емкость',
            STATE_BAT_HEALTH:       'Здоровье',
            STATE_BAT_STATUS:       'Состояние',
            STATE_BAT_VOLTAGE:      'Напряжение',
            STATE_LVB_SOH:          'Здоровье АКБ 12В',
            STATE_LVB_SOC:          'Емкость АКБ 12В',
            STATE_BATTERY_STATUS:   'Состояние АКБ 12В', 
            STATE_BATTERY_VOLTAGE:  'Напряжение АКБ 12В', 
            STATE_SOH_HV_AKB:       'Здоровье ВВ АКБ',
            STATE_SOC_HV_AKB:       'Емкость ВВ АКБ',

            STATE_COMMON_RIDE_TIME:         'Время в пути', 
            STATE_COMMON_MILEAGE:           'Пробег', 
            STATE_COMMON_FUEL_CONSUMPTION:  'Средний расход', 
            STATE_COMMON_AVERAGE_SPEED:     'Средняя скорость', 

            STATE_OCU_FL_STAT:  'Переднее левое сидение', 
            STATE_OCU_FR_STAT:  'Переднее правое сидение', 
            STATE_OCU_RL_STAT:  'Заднее левое сидение', 
            STATE_OCU_RR_STAT:  'Заднее правое сидение', 

            STATE_SAT: 'Кол-во видимых спутников', 

            STATE_TRIP_ACCELERATION:        'Кол-во ускорений', 
            STATE_TRIP_BRAKING:             'Кол-во торможений', 
            STATE_TRIP_DRIVING_ASSESSMENT:  'Оценка манеры вождения', 
            STATE_TOTAL_ACCELERATION:       'Кол-во ускорений (после сброса)', 
            STATE_TOTAL_BRAKING:            'Кол-во торможений (после сброса)', 
            STATE_ANS1:                     'ANS1',
            STATE_ANS2:                     'ANS2',
            STATE_ANS3:                     'ANS3',
            STATE_ANS4:                     'ANS4',
            STATE_ANS5:                     'ANS5',
            STATE_DIG1:                     'DIG1',
            STATE_DIG2:                     'DIG2',
            STATE_DIG3:                     'DIG3',
            STATE_DIG4:                     'DIG4',
            STATE_DIG5:                     'DIG5',
            STATE_ALARM_SYSTEM:             'Срабатывание штатной сигнализации',
            STATE_SRC:                      'Источник данных',
            STATE_CONN_TYPE:                'Тип соединения',
            STATE_MOV:                      'Движение',
            STATE_NOT_SET:                  'Не выбрано',

            // Тип связи с автомобилем
            CONNECTION_OFF:             'Нет связи',
            CONNECTION_ON:              'На связи',
            CONNECTION_LTE:             'LTE',
            CONNECTION_UMTS:            'UMTS',
            CONNECTION_GSM:             'GSM',

            ECUS_ADDITIONAL:                'Дополнительная информация',
            ECUS_STATUS_DESCR:              'Описание статусов',
            ECUS_DESCR_BADGES:              'Метки',
            ECUS_DESCR_GNSS:                'GNSS',
            ECUS_DESCR_GNSS_ONLINE:         'Блок GNSS на связи',
            ECUS_DESCR_GNSS_NOSATELLITES:   'Блок GNSS на связи, без спутников',
            ECUS_DESCR_GNSS_OFFLINE:        'Блок GNSS недоступен',
            ECUS_DESCR_ICON_ERROR:          'Количество активных ошибок',
            ECUS_DESCR_ICON_PASSIVE:        'Количество пассивных ошибок',
            ECUS_DESCR_ICON_WARNING:        'Предупреждения',
            ECUS_DESCR_BG:                  'Блоки',
            ECUS_DESCR_BG_ONLINE:           'Без ошибок / с пассивными ошибками',
            ECUS_DESCR_BG_OFFLINE:          'Отсутствует диагностика более 30 дней',
            ECUS_DESCR_BG_ERROR:            'С активными ошибками',
            ECUS_DESCR_BG_NO_INFO:          'Нет информации',

            ECUS_DIAG_REFRESH_SUCCESS:      'Диагностика запущена. Файлы отчётов будут обновлены', 

            HISTORY:                        'Архив показаний',
            HISTORY_DESCR:                  'Просмотр истории показаний приборов и датчиков за выбранный промежуток времени',
            HISTORY_REQUEST_TEXT:           'Выберите время начала и окончания показаний',
            HISTORY_START:                  'Начало',
            HISTORY_END:                    'Конец',
            HISTORY_SEARCH:                 'Поиск по названию...',
            HISTORY_PARAMS:                 'Параметры',
            HISTORY_TIME:                   'Время',
            HISTORY_ERROR_PARAMS:           'Параметры не выбраны!',
            HISTORY_ERROR_RANGE:            'Максимальный интервал для запроса графиков - 31 день',
            HISTORY_ERROR_TIME_INCORRECT:   'Время начала записи графиков должно быть раньше времени окончания',
            HISTORY_ERROR_TIME_EMPTY:       'Укажите даты начала и конца маршрута',
            HISTORY_EMPTY_POINTS:           'Нет записанных точек за указанный интервал времени',
            HISTORY_EMPTY_VALUE:            'Нет записанных состояний за указанный интервал времени',
            HISTORY_SHOW_GRID:              'Показать сетку',
            HISTORY_INSTRUCTION:            'Кликните на графике левой кл.мыши, затем потяните для увеличения выбранной области. Для перемещения графика зажмите Ctrl',
            HISTORY_INSTRUCTION_PANNING:    'Для увеличения масштаба растяните область на графике. Для сдвига графика проведите по нему двумя пальцами',

            FORM_REQUIRED:              'Поля, обязательные для заполнения', 

            RESET_TOKEN:                'Завершить все сеансы', 

            AGREE_PERSONAL_TEXT:        'Нажимая «Регистрация», Вы соглашаетесь с условиями ', 
            AGREE_PERSONAL_LINK:        'лицензионного договора',
            AGREE_PERSONAL_ERROR:       'Лицензионный договор', 

            PASS_INDICATOR_DESCR:       'Минимум 8 символов, одна строчная буква, одна заглавная буква, одна цифра и один символ _-%&',
            PASS_INDICATOR_E_LENGHT:    'Минимальная длина пароля - 8 символов', 
            PASS_INDICATOR_E_LETTER:    'Минимум одна строчная и заглавная буквы', 
            PASS_INDICATOR_E_NUMBER:    'Минимум одна цифра', 
            PASS_INDICATOR_E_SYMBOL:    'Минимум один символ _ - % &', 

            FOOTER_COPYRIGHT:           'Разработано ФГУП НАМИ, 2024 г.', 
            FOOTER_GOTOP:               'Наверх', 

            // 404
            NOTFOUND_SUBTITLE:            'Страница не найдена',
            NOTFOUND_LINK:                'На главную',

            // Areas
            EAreaNotFound:                'Геозоны не найдены',
            AREAS:                        'Геозоны',
            AREAS_LIST:                   'Список геозон',
            AREAS_DRAW_PANEL:             'Панель рисования',
            AREA:                         'Геозонa',
            AREA_CREATE:                  'Создать геозону',
            AREA_DELETE:                  'Удалить геозону',
            AREA_DELETE_QUESTION:         'Геозона будет удалена. Вы уверены, что хотите сделать это?',
            AREA_DELETE_SUCCESS:          'Геозона успешно удалена',
            AREA_CREATE_SUCCESS:          'Геозона успешно создана',
            AREA_UPDATE_SUCCESS:          'Геозона успешно обновлена',
            AREA_SEARCH_BY:               'Поиск по имени, описанию',
            AREA_SEARCH_ENTER:            'Введите минимум 3 символа',
            AREA_NAME:                    'Название',
            AREA_DESCRIPTION:             'Описание',
            AREA_FIGURE:                  'Фигура',
            AREA_FIGURE_TYPE:             'Тип фигуры',
            AREA_RADIUS:                  'Радиус',
            AREA_M:                       'м',
            AREA_STROKE_COLOR:            'Цвет линии',
            AREA_FILL_COLOR:              'Цвет заливки',
            AREA_WEIGHT:                  'Толщина линии',
            AREA_OUTLINE:                 'Контур',
            AREA_ENTER_NAME:              'Введите название геозоны',
            AREA_ENTER_DESCRIPTION:       'Введите описание геозоны',
            AREA_LAT:                     'Широта',
            AREA_LNG:                     'Долгота',
            AREA_DRAW_FIGURE:             'Нарисуйте фигуру',
            AREAS_UUID_NOT_FOUND:         'Не указан uuid геозоны',
            AREAS_NOT_FOUND:              'Геозоны не найдены',

            // Геозоны автомобиля
            CAR_AREAS_CTRL_TITLE:          'Настроить геозоны автомобиля',
            CAR_AREAS_DELETE_TITLE:        'Удалить событие геозоны автомобиля',
            CAR_AREAS_DELETE_TEXT:         'Это событие геозоны автомобиля будет удалено без возможности восстановления. Вы уверены, что хотите удалить его?',

            CAR_AREAS_AREA:                'Геозона',
            CAR_AREAS_EVENT:               'Событие',
            // CAR_AREAS_NOT_FOUND:           'Записей нет',
            CAR_AREAS_CREATE_SUCCESS:      'Событие геозоны добавлено',
            CAR_AREAS_SAVE_SUCCESS:        'События геозоны сохранены',
            CAR_AREAS_DELETE_SUCCESS:      'Событие геозоны удалено',

            FIRMWARES_TITLE:                'Прошивки', 
            FIRMWARES_FORM_METHOD:          'Способ загрузки', 
            FIRMWARES_FORM_METHOD_CARS:     'Выбранные автомобили', 
            FIRMWARES_FORM_METHOD_GROUPS:   'Группы автомобилей', 
            FIRMWARES_FORM_METHOD_ALL:      'Все автомобили', 
            FIRMWARES_FORM_SELECT_CARS:     'Добавите автомобили для загрузки прошивки.', 
            FIRMWARES_FORM_SELECT_GROUPS:   'Добавите группы автомобилей для загрузки прошивки.', 
            FIRMWARES_FORM_SELECT_WARNING:  'ВНИМАНИЕ! Вы выбрали способ загрузки - Все автомобили. Выбранная прошивка будет загружена во все автомобили!', 
            FIRMWARES_FORM_DEVICE:          'Версия устройства', 
            FIRMWARES_FORM_DEVICE_12:       'SDM v1.2', 
            FIRMWARES_FORM_DEVICE_30:       'SDM v3.0', 
            FIRMWARES_FORM_DEVICE_IC_217:   'НАМИ-Интелком 2.1.7', 
            FIRMWARES_FORM_DEVICE_IC_21713: 'НАМИ-Интелком 2.1.7 (1.3)', 
            FIRMWARES_FORM_DEVICE_IC_21714: 'НАМИ-Интелком 2.1.7 (1.4)', 
            FIRMWARES_FORM_FILE:            'Файл прошивки', 
            FIRMWARES_FORM_MODULE:          'Модуль', 
            FIRMWARES_FORM_VERSION:         'Версия прошивки', 
            FIRMWARES_CREATE_SELECT_ELEMENTS: 'Выберите элемента для загрузки прошивок',
            FIRMWARES_CREATE_SUCCESS:       'Файл прошивки успешно загруженн', 
            FIRMWARES_UPDATE:               'Информация о прошивке', 
            FIRMWARES_UPDATE_SUCCESS:       'Информация о прошивке успешно обновлена', 
            FIRMWARES_DELETE:               'Удаление прошивки', 
            FIRMWARES_DELETE_DESCR:         'Выбранный файл прошивки будет удалён. Устройства, которые ещё не получили этот файл или его загрузка не закончена не получат его. Вы уверены, что хотите сделать это?', 
            FIRMWARES_DELETE_SUCCESS:       'Файл прошивки успешно удалён', 
            FIRMWARES_SEARCH_MODE_ALL:      'Все', 
            FIRMWARES_SEARCH_MODE_DEVICE:   'Тип устройства',  
            FIRMWARES_SEARCH_MODE_MODULE:   'Модуль', 
            FIRMWARES_SEARCH_MODE_VERSION:  'Версия прошивки', 
            FIRMWARES_NAME:                 'Имя файла', 
            FIRMWARES_DEVICE:               'Устройство', 
            FIRMWARES_MODULE:               'Модуль', 
            FIRMWARES_VERSION:              'Прошивка', 
            FIRMWARES_SELECTOR:             'Выберите получателей', 
            FIRMWARES_SELECTOR_LINK:        'Добавить', 

            ECaptchaError:              'Ошибка при вводе проверочного кода', 
            EFormFields:                'Ошибка заполнения формы', 
            EEmail:                     'Указанный e-mail не найден', 
            EUserPhoneAlreadyExist:     'Такой телефон уже зарегистрирован',
            EImei:                      'Некорректный IMEI', 
            EVin:                       'Некорректный VIN', 
            EUserNotFound:              'Пользователь не найден', 
            EUserVerifyLink:            'Неверный код верификации учётной записи', 
            EConnection:                'При обращении к серверу произошла ошибка. Попробуйте повторить запрос позже.', 
            EUserEmailAlreadyExist:     'Указанный e-mail уже зарегистрирован', 
            ECGroupNotFound:            'Группы автомобилей не найдены', 
            ELinkNotFound:              'Связи не найдены', 
            ECarNotFound:               'Автомобили не найдены', 
            ECarImeiAlreadyExist:       'Автомобиль с таким IMEI уже существует', 
            ECarNotOnLine:              'Ошибка выполнения команды: нет связи с автомобилем', 
            ECarPointNotFound:          'За выбранный интервал времени данных не найдено',
            ELinkAlreadyExist:          'Эта связка уже существует', 
            EUnknown:                   'В работе приложения произошла ошибка. Если ошибка будет повторяться, пожалуйста, обратитесь к администратору.',
            EUGroupNotFound:            'Группа не найдена', 
            EEventNotFound:             'События не найдены', 
            EEventsSubsUuid:            'Неизвестный UUID автомобиля', 
            EEgtsReportNotFound:        'Файлы отчётов не найдены',
            ECommandResponseUnknownAddress: 'Ошибка: неизвестный инентификаток ЭБУ',
            EEgtsFirmwareNotFound:      'Файлы прошивок не найдены', 
            EPermissionDenied:          'У вас нет доступа к этой информации', 
            EUserSelfUGroup:            'Вы не можете изменять группу пользователей для себя', 
            EPassword:                  'Введённый пароль не соответствует минимальным требованиям',
            EUserPassword:              'Ошибка при вводе пароля', 
            ELogNotFound:               'Отчётов за выбранный период не найдено', 
            EEmailOrPhone:              'Ошибка в имени пользователя', 
            ECodeError:                 'Введён невалидный код подтверждения', 
            EUserIsNotActivated:        'Ваша учётная запись не активирована. Проверьте почту (e-mail), указанную при регистрации и перейдите по ссылке из письма.',
            ECertificateNotFound:       'Сертификат не найден', 
            ECommandResponseNotRespond: 'ЭБУ не распознан', 
            ECommandResponseUnknownCommand: 'Неизвестная команда', 
            EIccid:                     'Введён неверный код активации', 
            EEventParamAlreadyExist:    'Вы уже подписаны на выбранное событий', 
            ECarRequestOwnerICCIDVinMismatch: 'Введён неверный код активации',
            EQuery:                     'Строка содержит запрещенные символы',
            EFavoriteFound:             'У вас нет избранных автомобилей', 
            EEventParamNotFound:        'События геозон не найдены', 
            ECarTripsNotFound:          'Поездки автомобиля не найдены', 
            EEgtsFirmwareAlreadyExist:  'Прошивка для этого устройства уже загружена. Для замены файла прошивки сначала удалите существующий.',

            TOKEN_BAD_REQUEST:           'Не удалось получить токен.',
            TOKEN_REPEAT_REQUEST:        'Повтор через'
        },

        EN: {

            YES:                        'Yes', 
            NO:                         'No', 

            BTN_ADD:                    'Add',
            BTN_CREATE:                 'Create', 
            BTN_SELECT:                 'Select', 
            BTN_EDIT:                   'Edit',
            BTN_CTRL:                   'Control',
            BTN_SAVE:                   'Save',
            BTN_UPDATE:                 'Update', 
            BTN_CANCEL:                 'Cancel',
            BTN_DELETE:                 'Delete',
            BTN_REQUEST:                'Request', 
            BTN_FAVORITES:              'Favorites', 
            BTN_READMORE:               'Readmore', 
            BTN_UPLOAD:                 'Upload', 
            BTN_SEND:                   'Send',
            BTN_CLOSE:                  'Close', 
            BTN_MAP:                    'Map',
            BTN_REISSUE:                'Reissue', 

            // Units
            UNIT_KM:                    'km',
            UNIT_KMH:                   'km/h',
            UNIT_METRE:                 'm',
            UNIT_DAY:                   'd',
            UNIT_HOUR:                  'h',
            UNIT_MINUTE:                'min',
            UNIT_SECOND:                's',
            UNIT_SECOND_LONG:           'sec.',
            UNIT_MLITER:                'ml',
            UNIT_LITER:                 'l',
            UNIT_LITER_100_KM:           'l/100km',
            UNIT_ATM:                   'atm',
            UNIT_RPM:                   'rpm',
            UNIT_VOLT:                  'V',

            ONLINE:                     'Online',
            OFFLINE:                    'Offline',

            ATTRS:                      'Attributes', 
            ATTRS_DEVELOPER:            'Developer mode', 
            ATTR_LOGS_CAR:              'Cars log', 
            ATTR_EDIT_PRIVATE_CAR:      'Edit manufactorer info', 
            ATTR_GEODATA:               'Navigation information', 
            ATTR_REMOTE_CONTROL:        'Remote control', 
            ATTR_DIAGNOSTIC:            'ECU reports', 
            ATTR_PARAM:                 'Edit GNSS params', 
            ATTR_FIRMWARE:              'Firmwares', 
            ATTR_MULTI_FIRMWARE:        'Multi firmwares',
            ATTR_COMMAND:               'Send GNSS commands', 
            ATTR_GROUP_ADMIN:           'Users group admin', 
            ATTR_SUPER_ADMIN:           'Super admin', 
            ATTR_CREATOR_CAR:           'Add cars', 
            ATTR_SEER_CAR:              'Access to all cars', 
            ATTR_CERTIFICATE_ADMIN:     'Certificate management', 

            CERTIFICATES:                   'Certificates', 
            CERTIFICATE:                    'Certificate', 
            CERTIFICATES_ISSUE:             'Issue', 
            CERTIFICATES_CRT:               'Crt',
            CERTIFICATES_KEY:               'Key',  
            CERTIFICATES_CREATE:            'Issue certificate', 
            CERTIFICATES_CREATE_SUCCESS:    'Certificate successfuly issued', 
            CERTIFICATES_UPDATE:            'Re-issue sertificate', 
            CERTIFICATES_UPDATE_SUCCESS:    'Certificate successfuly re-issued',  
            CERTIFICATES_DELETE:            'Removing a certificate', 
            CERTIFICATES_DELETE_DESCR:      'This certificate will be permanently deleted. Are you sure you want to do this?', 
            CERTIFICATES_DELETE_SUCCESS:    'Certificate deleted', 
            CERTIFICATES_CHANGE_WARN:       'WARNING! When you create a new certificate, the old one will be deleted!',
            CERTIFICATES_DATE_START:        'Start date', 
            CERTIFICATES_DATE_STOP:         'End date', 
            CERTIFICATES_IMEI:              'IMEI',
            CERTIFICATES_INFO:              'Certificate description',
            CERTIFICATES_DOWNLOAD_CRT:      'Download CRT',
            CERTIFICATES_DOWNLOAD_KEY:      'Download KEY',

            SEARCH:                     'Search', 

            MENU_AUTH:                  'Log-in',
            MENU_REGISTRATION:          'Registration',
            MENU_FORGOT:                'Forgot password',
            MENU_MAIN:                  'Main', 
            MENU_CARS:                  'Cars', 
            MENU_CAR:                   'Car', 
            MENU_CAR_INFO:              'Information',
            MENU_CAR_DIAG:              'Diagnostic',
            MENU_CAR_ECU:               'ECU',
            MENU_CAR_GNSS:              'GNSS', 
            MENU_CAR_MAP:               'Map',
            MENU_CAR_AREAS:             'Areas',
            MENU_CAR_STATES:            'States', 
            MENU_CAR_RIGHTS:            'Rights', 
            MENU_CAR_EVENTS:            'Events', 
            MENU_CAR_EVENT:             'Event', 
            MENU_CAR_EVENT_DATE:        'Date', 
            MENU_CAR_HISTORY:           'History', 
            MENU_CAR_TRIPS:             'Trips', 
            MENU_DRIVERS:               'Drivers', 
            MENU_DRIVER:                'Driver', 
            MENU_USER_CREATE:           'Create user', 
            MENU_USER_INFO:             'Information', 
            MENU_USER_CARS:             'Cars', 
            MENU_USER_LOGS:             'Logs', 
            MENU_USER_PASS:             'Password', 
            MENU_PROFILE:               'Profile', 
            MENU_CARS_GROUPS:           'Cars groups', 
            MENU_CARS_GROUP:            'Cars group', 
            MENU_CARS_GROUP_INFO:       'Information', 
            MENU_CARS_GROUP_CARS:       'Cars',
            MENU_CARS_GROUP_USERS_GROUPS: 'Users groups', 
            MENU_USERS:                 'Users',
            MENU_USERS_GROUPS:          'Users groups', 
            MENU_USERS_GROUP:           'Users group', 
            MENU_USERS_GROUP_USERS:     'Drivers', 
            MENU_USERS_GROUP_CARS:      'Cars', 
            MENU_USERS_GROUP_CARS_GROUPS: 'Groups cars',
            MENU_FIRMWARES:             'Firmwares',
            MENU_FIRMWARE:              'Firmware',

            SMART_CAPTCHA_POLICY:       'We using', 
            SMART_CAPTCHA_ERROR_LOAD:   'Captcha loading error',
            SMART_CAPTCHA_ERROR_JS:     'Captcha internal error',
            SMART_CAPTCHA_ERROR_NETWORK:'Captcha network error',
            SMART_CAPTCHA_ERROR_METHOD: 'Method window.smartCaptcha not defined',

            AUTH:                       'Authhorization', 
            AUTH_LOGIN:                 'Login', 
            AUTH_PASS:                  'Password', 
            AUTH_AGREE:                 'User agreement', 
            AUTH_CAPTCHA:               'Captcha', 
            AUTH_SUBMIT:                'Login',
            AUTH_REGISTRATION:          'Registration', 
            AUTH_FORGOT:                'Forgot password', 

            REGISTRATION:               'Sign up', 
            REGISTRATION_LINK:          'Sign up', 
            REGISTRATION_LOGIN:         'E-mail', 
            REGISTRATION_NAME:          'Name', 
            REGISTRATION_LASTNAME:      'Last name', 
            REGISTRATION_SURNAME:       'Surname', 
            REGISTRATION_PHONE:         'Phone', 
            REGISTRATION_PASS:          'Password', 
            REGISTRATION_CAPTCHA:       'Captcha code', 
            REGISTRATION_AGREE:         'Agreement with the license agreement', 
            REGISTRATION_SUBMIT:        'Sign up', 
            REGISTRATION_SUCCESS:       'A link to activate your account will be sent to your email address.', 
            REGISTRATION_AUTH:          'Sign in', 
            REGISTRATION_ERROR_FIELDS:  'Check that the form is filled out correctly', 
            REGISTRATION_VERIFIED:      'The account has been successfully activated. Now you can log-in using the e-mail and password specified during registration.',

            FORGOT_EMAIL:               'E-mail', 
            FORGOT_CODE:                'Verification code', 
            FORGOT_CODE_DESCR:          'An email with a verification code has been sent to the email address you provided. Enter the code from the letter in the field below.', 
            FORGOT_LOGIN:               'Log-in', 

            PROFILE_LOGOUT:             'Logout',

            CARS_TITLE:                 'Cars', 
            CARS_ONLINE:                'Status', 
            CARS_FILTER_ONLINE:         'Only online', 
            CARS_VIN:                   'VIN', 
            CARS_VIN_EMPTY:             'VIN not specified', 
            CARS_NUMBER:                'Reg.number', 
            CARS_MODEL:                 'Model', 
            CARS_NAMI_NUMBER:           'Manufactorer code', 
            CARS_IMEI:                  'IMEI', 
            CARS_READMORE:              'Readmore', 
            CARS_SEARCH_MODE_ALL:       'All',
            CARS_SEARCH_MODE_VIN:       'VIN',
            CARS_SEARCH_MODE_TID:       'id GNSS',
            CARS_SEARCH_MODE_IMEI:      'IMEI',
            CARS_SEARCH_MODE_NUMBER:    'Car number',
            CARS_SEARCH_MODE_NAMI:      'Manuf. code',
            CARS_SEARCH_MODE_PHONE:     'Phone', 
            CARS_SEARCH_MODE_ICCID:     'ICCID', 
            CARS_NAME:                  'Name', 
            CARS_EMPTY:                 'Cars not found', 

            CARS_CREATE_HEADER:         'Add car', 
            CARS_ADD_HEADER:            'Create car', 
            CARS_CREATE_VIN:            'VIN', 
            CARS_CREATE_NUMBER:         'Reg.number', 
            CARS_CREATE_IMEI:           'IMEI', 
            CARS_CREATE_ICCID:          'Activation code', 
            CARS_CREATE_NAMI_NUMBER:    'Manufactorer code', 
            CARS_CREATE_TID:            'ID GNSS', 
            CARS_CREATE_NAME:           'Name', 
            CARS_CREATE_PHONE:          'Phone', 
            CARS_CREATE_STATE:          'Description', 
            CARS_CREATE_COLOR:          'Color', 
            CARS_CREATE_CAPTCHA:        'Captcha code', 

            CARS_DELETE:                'Delete car', 
            CARS_DELETE_DESCR:          'This vehicle will be permanently deleted. Are you sure you want to do this?', 
            CARS_DELETE_SUCCESS:        'Car deleted', 

            // Car colors
            CAR_COLOR_BLACK_COPPER:     "Black copper",
            CAR_COLOR_BLUE_MAGIC:       "Blue magic",
            CAR_COLOR_DEEP_FOREST:      "Deep forest",
            CAR_COLOR_DESERT_RED:       "Desert red",
            CAR_COLOR_DESERT_TAUPE:     "Desert taupe",
            CAR_COLOR_GALANT_GREY:      "Galant grey",
            CAR_COLOR_GRAPHITE_TRACE:   "Graphite trace",
            CAR_COLOR_LATTE_MACCHIATO:  "Latte macchiato",
            CAR_COLOR_LUSTRE_WHITE:     "Lustre white",
            CAR_COLOR_NOT_SET:          "Not set",
            CAR_COLOR_PORCELAIN:        "Porcelain",
            CAR_COLOR_PULSAR_BLUE:      "Pulsar blue",
            CAR_COLOR_RUSSIAN_GOLD:     "Russian gold",
            CAR_COLOR_SHADE_OF_NIGHT:   "Shade of night",
            CAR_COLOR_SILVER_LINING:    "SIlver lining",
            CAR_COLOR_SUNSET_GOLD:      "Sunset gold",
            CAR_COLOR_UNIVERSE_BLACK:   "Universe black",
            CAR_COLOR_VELVET_RUBY:      "Velvet ruby",

            CAR_RIGHTS:                 'Rights & access', 
            CAR_RIGHTS_USERS_GROUPS:    'Users groups', 
            CAR_RIGHTS_USERS_GROUPS_NAME: 'Name', 
            CAR_RIGHTS_USERS_GROUPS_DESCR: 'Describtion', 
            CAR_RIGHTS_USERS_GROUPS_CREATE: 'Add users group', 
            CAR_RIGHTS_USERS_GROUPS_CREATE_SUCCESS: 'Users group added', 
            CAR_RIGHTS_USERS_GROUPS_UPDATE_SUCCESS: 'Car users groups updated', 
            CAR_RIGHTS_USERS_GROUPS_DELETE: 'Delete users group', 
            CAR_RIGHTS_USERS_GROUPS_DELETE_DESCR: 'This group of users will lose access to the vehicle. Are you sure you want to do this?',
            CAR_RIGHTS_USERS_GROUPS_DELETE_SUCCESS: 'A group of users have lost access to the car',

            CAR_ECUS:                   'Diagnostic', 
            CAR_ECUS_REFRESH:           'Refresh reports', 
            CAR_ECUS_REPORTS_DELETE:    'Delete reports', 
            CAR_ECUS_EXPORT:            'Export', 
            CAR_ECUS_ADDITIONAL:        'Additional', 

            CAR_USERS:                  'Car users', 
            CAR_USERS_CREATE:           'Add car users', 
            CAR_USERS_CREATE_SUCCESS:   'Car user added', 
            CAR_USERS_UPDATE_SUCCESS:   'Car users updated', 
            CAR_USERS_DELETE:           'Delete car user', 
            CAR_USERS_DELETE_DESCR:     'The selected user will lose access to this vehicle. Are you sure you want to do this?', 
            CAR_USERS_DELETE_SUCCESS:   'Car user deleted', 

            CAR_USERS_GROUPS_EMPTY:     'Car users groups not found', 

            CAR_GROUPS:                 'Car groups', 
            CAR_GROUPS_EMPTY:           'Car groups not found', 
            CAR_GROUPS_CREATE:          'Add car groups', 
            CAR_GROUPS_CREATE_SUCCESS:  'Group added in the car', 
            CAR_GROUPS_DELETE:          'Delete car group', 
            CAR_GROUPS_DELETE_DESCR:    'The vehicle will be excluded from the selected group. Are you sure you want to do this?', 
            CAR_GROUPS_DELETE_SUCCESS:  'Group deleted from the car', 

            CAR_EVENTS:                 'Events', 
            CAR_EVENTS_START:           'From', 
            CAR_EVENTS_END:             'Till', 
            CAR_EVENTS_FILTER:          'Filter', 
            CAR_EVENTS_EVENT:           'Event', 
            CAR_EVENTS_DATE:            'Date', 
            CAR_EVENTS_MAP:             'Map',
            CAR_EVENTS_ERROR_MAX_PERIOD:'Maximum event request period - 31 days',
            CAR_EVENTS_ERROR_INVALID_LIMITS: 'The start time of reports must be less than the end time',
            CAR_EVENTS_ERROR_NO_LIMITS: 'Specify start and end times for reports', 
            EVENTS_SUBS_DESCR:          "You can subscribe to events related to this vehicle. If they occur, you'll receive a notification to the email address specified in your profile.",
            EVENTS_SUBS_CREATE_SUCCESS: 'Subscribe successfuly added',
            EVENTS_SUBS_DELETE_SUCCESS: 'Unsubscribed',

            CAR_STATUS_ONLINE:          'Online', 
            CAR_STATUS_OFFLINE:         'Offline', 

            CAR_STATES:                 'State',

            CAR_MAP_EVENTS:               'Events',
            CAR_MAP_EVENT_SECURE:         'Secure',
            CAR_MAP_EVENT_SECURE_ADD:     'On/off',
            CAR_MAP_EVENT_ENGINE:         'Engine',
            CAR_MAP_EVENT_ENGINE_ADD:     'Start/stop',
            CAR_MAP_EVENT_TRUNK:          'Trunk',
            CAR_MAP_EVENT_TRUNK_ADD:      'Open/close',
            CAR_MAP_EVENT_ZONE:           'Secure zone',
            CAR_MAP_EVENT_ZONE_ADD:       'Enter/exit',
            CAR_MAP_EVENT_LIGHT:          'Light and signal',
            CAR_MAP_EVENT_MILEAGE:        'Reducing mileage',
            CAR_MAP_EVENT_VOLTAGE:        'Low battery charge',

            CAR_TRIP:                     'Trip',
            CAR_TRIPS:                    'Trips', 
            CAR_TRIPS_ACCELERATION:       'Accelerations', 
            CAR_TRIPS_BRAKING:            'Braking', 
            CAR_TRIPS_FUELCONSUMPTION:    'Fuel consumption', 
            CAR_TRIPS_MILEAGE:            'Mileage', 
            CAR_TRIPS_STARTEDAT:          'Start date', 
            CAR_TRIPS_ENDEDAT:            'Ended date', 
            CAR_TRIPS_TIME:               'Duration', 
            CAR_TRIPS_DRIVING_ASSESSMENT: 'Driving assessment',
            CAR_TRIPS_WITH_MILEAGE:       'With mileage only',

            // Body types
            CARTYPE_SEDAN:                   'Sedan',
            CARTYPE_SEDAN_ARMORED:           'Sedan armored',
            CARTYPE_LIMO_ARMORED_V12:        'Limo armored',
            CARTYPE_LIMO_ARMORED_V8:         'Limo armored',
            CARTYPE_LIMO_ARMORED_V8_CIVIL:   'Limo armored (civil)',
            CARTYPE_CABRIO:                  'Cabriolet',
            CARTYPE_CABRIO_SHOW:             'Cabriolet show',
            CARTYPE_SEDAN_4X2:               'Sedan 4x2',
            CARTYPE_SEDAN_LONG:              'Sedan long',
            CARTYPE_SEDAN_LONG_ARMORED:      'Sedan long armored',
            CARTYPE_SUV:                     'SUV',
            CARTYPE_SUV_ARMORED:             'SUV armored',
            CARTYPE_MPV_4_SEATS:             'MPV 4 seats',
            CARTYPE_MPV_ARMORED_4_SEATS:     'MPV armored 4 seats',
            CARTYPE_MPV_ARMORED_8_SEATS:     'MPV armored 8 seats',
            CARTYPE_MPV_9_SEATS:             'MPV 9 seats',
            CARTYPE_MPV_ARMORED_9_SEATS:     'MPV armored 9 seats',
            CARTYPE_MPV_ORBITA:              'MPV Orbita',
            CARTYPE_MPV_TABLETKA:            'MPV Tabletka',
            CARTYPE_RESERVED:                'Reserve',
            CARTYPE_UNKNOWN:                 'Unknown body',

            FAVORITE_CARS_CREATE_SUCCESS:   'Car successfuly added in favorites', 
            FAVORITE_CARS_DELETE_SUCCESS:   'Car successfuly deleted from favorites', 

            // Suspension types
            SUSPENSION_CONVENTIONAL:       'Convensional',
            SUSPENSION_AIR:                'Air',
            SUSPENSION_DUAL_AIR:           'Air (dual)',

            CARINFO_HEADER:             'Information', 
            CARINFO_BODY_TYPE:          'Body', 
            CARINFO_ENGINE:             'Engine', 
            CARINFO_MANUFACTORER:       'Manufactorer', 
            CARINFO_COLOR:              'Color', 
            CARINFO_VIN:                'VIN', 
            CARINFO_VIN_UPDATE:         'VIN update', 
            CARINFO_ICCID:              'ICC ID', 
            CARINFO_EICCID:             'ERA ICC ID', 
            CARINFO_MANUFACTORER_CODE:  'Manufactorer code', 
            CARINFO_NAME:               'Name', 
            CARINFO_SUSPENSION:         'Suspension', 
            CARINFO_CAR_NUMBER:         'Registration number', 
            CARINFO_STATE:              'Describtion', 
            CARINFO_TID:                'ID GNSS', 
            CARINFO_IMEI:               'IMEI', 
            CARINFO_GNSS_PHONE:         'GNSS phone', 
            CARINFO_PLATFORM:           'Platform', 
            CARINFO_UUID:               'UUID', 
            CARINFO_MODEL:              'Model', 
            CARINFO_YEAR:               'Model year', 
            CARINFO_TELEMATIC:          'Always connected', 
            CARINFO_CREATED:            'Created', 
            CARINFO_UPDATE_SUCCESS:     'Car info successfuly updated', 

            CARMAP_TRACK_TITLE:         'Viewing trip tracks', 
            CARMAP_TRACK_START:         'Trip start', 
            CARMAP_TRACK_FINISH:        'Trip finish', 
            CARMAP_TRACK_TODAY:         'Today', 
            CARMAP_TRACK_YESTERDAY:     'Yesterday', 
            CARMAP_TRACK_WEEK:          'Week', 
            CARMAP_CRASH:               'Failed to load maps. Try refreshing the page (Ctrl+F5) or coming back later. If the error persists, contact the administrator!', 
            CARMAP_SPEED:               'Speed', 
            CARMAP_UPDATE_DATE:         'Updated at', 

            USERS:                      'Drivers', 
            USERS_EMPTY:                'Users not found', 
            USERS_CREATE_HEADER:        'Add driver', 
            USERS_SEARCH_MODE_ALL:      'All', 
            USERS_SEARCH_MODE_EMAIL:    'E-mail', 
            USERS_SEARCH_MODE_PHONE:    'Phone', 
            USERS_SEARCH_MODE_NAME:     'Name', 
            USERS_SEARCH_MODE_MIDNAME:  'Middle name', 
            USERS_SEARCH_MODE_SURNAME:  'Surname', 
            USERS_NEW_USER:             'New user',
            USERS_READMORE:             'Readmore', 
            USERS_DELETE:               'Delete user', 
            USERS_DELETE_DESCR:         'This user will be permanently deleted. Are you sure you want to do this?', 
            USERS_DELETE_SUCCESS:       'The selected user has been deleted.', 

            USER_INFO:                  'Information', 
            USER_NAME:                  'Name', 
            USER_SURNAME:               'Surname', 
            USER_LASTNAME:              'Lastname', 
            USER_EMAIL:                 'E-mail', 
            USER_PHONE:                 'Phone', 
            USER_CODE:                  'Verification code', 
            USER_GROUP:                 'Group', 
            USER_LOGS:                  'User logs',
            USER_LOGS_DATE:             'Date', 
            USER_LOGS_ACTION:           'Action', 
            USER_LOGS_LEVEL:            'Level',
            USER_LOGS_DETAILS:          'Details', 
            USER_PASS:                  'Password', 
            USER_PASS_REPEAT:           'Repeat password', 
            USER_UPDATE_SUCCESS:        'User information updated', 
            USER_ATTR_WARNING:          'If a user пgroup or attributes are changed, all of his sessions will be deleted. He will need to re-authorize on all devices.',
            USER_GROUP_EMPTY:           'No group',
            USER_GROUPS:                'User groups', 
            USER_STATUS_LOCK:           'Block user', 
            USER_STATUS_ACTIVE:         'User active',
            USER_STATUS_LOCKED:         'User banned',
            USER_UPDATED:               'Last update', 
            USER_CARS:                  'User cars', 
            USER_CARS_CREATE:           'Add cars',
            USER_CARS_CREATE_SUCCESS:   'The car was successfully added to the user', 
            USER_CARS_DELETE:           'Delete car', 
            USER_CARS_DELETE_DESCR:     'The user will lose access to this vehicle. Are you sure you want to do this?', 
            USER_CARS_DELETE_SUCCESS:   'The user has lost access to the selected vehicle', 

            // Create user
            USER_CREATE_NAME:           'Name',
            USER_CREATE_MID_NAME:       'Surname', 
            USER_CREATE_LAST_NAME:      'Last name', 
            USER_CREATE_ATTR:           'Attributes',
            USER_CREATE_TYPE:           'Type',
            USER_CREATE_GROUP:          'Group',
            USER_CREATE_GROUP_EMPTY:    'No group',
            USER_CREATE_GROUP_NEW:      'New',
            USER_CREATE_GROUP_NEW_NAME: 'Name', 
            USER_CREATE_GROUP_NEW_DESCR:'Description', 
            USER_CREATE_EMAIL:          'E-mail',
            USER_CREATE_PHONE:          'Phone',
            USER_CREATE_PASS:           'Password', 
            USER_CREATE_PASS_REPEAT:    'Repeat password',
            USER_CREATE_PASS_DESCR:     'Minimum 8 characters, one lowercase letter, one uppercase letter, one number and one _-%& symbol',

            // User types
            USER_TYPE:                  'User type',
            USER_TYPE_USER:             'User',
            USER_TYPE_EXPERT:           'Expert',
            USER_TYPE_SUPER:            'Administrator',
            USER_TYPE_SUPER_DESCR:      'WARNING! This user have been full access for application.',

            CARS_GROUPS:                'Cars groups', 
            CARS_GROUPS_CREATE:         'Create cars group', 
            CARS_GROUPS_CREATE_SUCCESS: 'Cars group successfuly created', 
            CARS_GROUPS_CREATE_NAME:    'Name', 
            CARS_GROUPS_CREATE_DESCR:   'Description', 
            CARS_GROUPS_DELETE:         'Delete cars group', 
            CARS_GROUPS_DELETE_DESCR:   'This group of cars will be deleted permanently. Are you sure you want to do this?', 
            CARS_GROUPS_DELETE_SUCCESS: 'Cars group successfuly deleted', 

            CARS_GROUP:                 'Cars group', 
            CARS_GROUP_INFO:            'Information', 
            CARS_GROUP_UPDATE_SUCCESS:  'Cars group information updated', 
            CARS_GROUP_USERS_GROUPS:    'Users groups', 
            CARS_GROUP_USERS_GROUPS_CREATE: 'Add users group', 
            CARS_GROUP_USERS_GROUPS_CREATE_SUCCESS: 'Users group added', 
            CARS_GROUP_USERS_GROUPS_UPDATE_SUCCESS: 'Users group updated', 
            CARS_GROUP_USERS_GROUPS_DELETE: 'Delete users group', 
            CARS_GROUP_USERS_GROUPS_DELETE_DESCR: 'The user group will lose access to this vehicle. Are you sure you want to do this?', 
            CARS_GROUP_USERS_GROUPS_DELETE_SUCCESS: 'Users group deleted', 

            CARS_GROUPS_NAME:           'Name', 
            CARS_GROUPS_DESCR:          'Description', 

            CARS_GROUP_CARS:            'Group cars', 
            CARS_GROUP_CARS_EMPTY:      'Group cars not found', 
            CARS_GROUP_CARS_CREATE:     'Add car',
            CARS_GROUP_CARS_CREATE_SUCCESS: 'Car added in the group', 
            CARS_GROUP_CARS_DELETE_HEADER: 'Delete car', 
            CARS_GROUP_CARS_DELETE_DESCR: 'This car will be removed from the group without the possibility of restoration. Are you sure you want to do this?', 
            CARS_GROUP_CARS_DELETE_SUCCESS: 'Car deleted from the group', 

            USERS_GROUPS:               'Users groups', 
            USERS_GROUPS_NAME:          'Name',
            USERS_GROUPS_DESCR:         'Description', 
            USERS_GROUPS_CREATE:        'Create users group', 
            USERS_GROUPS_CREATE_NAME:   'Name', 
            USERS_GROUPS_CREATE_DESCR:  'Description', 
            USERS_GROUPS_UPDATE_SUCCESS:'Users group successfuly updated', 
            USERS_GROUPS_CREATE_SUCCESS:'Users group successfuly created', 
            USERS_GROUPS_DELETE:        'Delete users group', 
            USERS_GROUPS_DELETE_DESCR:  'This user group will be permanently deleted. Are you sure you want to do this?', 
            USERS_GROUPS_DELETE_SUCCESS:'Users group successfuly deleted', 

            USERS_GROUP_INFO:           'Information', 
            USERS_GROUP_DRIVERS:        'Drivers', 
            USERS_GROUP_CARS:           'Cars', 
            USERS_GROUP_CARS_GROUPS:    'Groups cars',
            USERS_GROUP_CARS_GROUPS_EMPTY: 'Cars groups not found', 
            USERS_GROUP_CARS_GROUPS_CREATE: 'Add cars groups', 
            USERS_GROUP_CARS_GROUPS_CREATE_SUCCESS: 'Cars group successfuly added', 
            USERS_GROUP_CARS_GROUPS_UPDATE_SUCCESS: 'Cars group attributes updated', 
            USERS_GROUP_CARS_GROUPS_DELETE: 'Unlink cars group', 
            USERS_GROUP_CARS_GROUPS_DELETE_DESCR: 'This user group will lose access to the selected group of cars. Are you sure you want to do this?', 
            USERS_GROUP_CARS_GROUPS_DELETE_SUCCESS: 'Cars group successfuly unlinked', 
            USERS_GROUP_USERS_NAME:     'Name', 
            USERS_GROUP_USERS_EMAIL:    'E-mail', 
            USERS_GROUP_USERS_CREATE:   'Add a group user',
            USERS_GROUP_USERS_CREATE_SUCCESS: 'User successfully added to group', 
            USERS_GROUP_USERS_DELETE:   'Delete user', 
            USERS_GROUP_USERS_DELETE_DESCR: 'The user will be removed from the selected group. Are you sure you want to do this?', 
            USERS_GROUP_USERS_DELETE_SUCCESS: 'The user has been successfully removed from the group', 

            EVENT_VIN:                  'VIN',
            EVENT_TYPE:                 'Event',
            EVENT_SEARCH:               'Search events',
            EVENT_DATE:                 'Date',
            EVENT_MAP:                  'Event on map',
            EVENT_COORDS:               'Coordinates',
            EVENT_GOTO_CAR:             'Go to car',
            EVENT_ALL:                  'All',
            EVENT_ENGINE_ON:            'Turning on the engine',
            EVENT_REMOTE_ENGINE_ON:     'Remote engine start-up',
            EVENT_ENGINE_OFF:           'Turning off the engine',
            EVENT_DECREASE_MILEAGE:     'Decrease in total mileage',
            EVENT_PROTECTED_AREA_IN:    'Entrance to the security zone',
            EVENT_PROTECTED_AREA:       'Exit from the security zone',
            EVENT_UNLOCKED:             'Disarming the vehicle',
            EVENT_LOCKED:               'Putting the car under protection',
            EVENT_CMD_ENGINE_ON:        'The command to start the engine has been sent',
            EVENT_CMD_ENGINE_OFF:       'The command to stop the engine was sent',
            EVENT_CMD_UNLOCK:           'A command to disarm has been sent',
            EVENT_CMD_LOCK:             'A team has been sent to secure it',
            EVENT_CMD_TRUNK_OPEN:       'A command was sent to open the trunk',
            EVENT_CMD_TRUNK_CLOSE:      'Sent a command to close the trunk',
            EVENT_CMD_LIGHT:            'The flash lights command was sent',
            EVENT_CMD_BEEP:             'The beep command has been sent',
            EVENT_LOW_BATTERY_VOLTAGE:  'Low battery charge',
            EVENT_ALARM_SYSTEM_TRIGGERED:'Triggering of the standard alarm',
            EVENT_NOT_SET:               'Not set',

            // UTACarMapList
            EVENTS_TRIP_TRACKS:         'Trip tracks',

            // ECU
            ECU_EXPORT:                 'Export report',
            ECU_INFO:                   'Information',
            ECU_ERRORS:                 'Errors',
            ECU_ERRORS_ONLY_ACTIVE:     'Only active',
            ECU_REPORTS:                'Reports',
            ECU_REPORTS_DISABLED:       'Charts online / Online telemetry: development is on hold',
            ECU_SERIAL:                 'Serian no.',
            ECU_HARDWARE:               'Hardware',
            ECU_FIRMWARE:               'Firmware',
            ECU_VIN:                    'ECU VIN',
            ECU_CALIBRATION:            'Calibration',
            ECU_MILEAGE:                'Milleage',
            ECU_SOFTWARE:               'Software',
            ECU_TIMESTAMP:              'Last diagnistic time',
            ECU_ERRORS_EMPTY:           'No errors detected',
            ECU_HISTORY:                'Reports history',
            ECU_FILE:                   'Files',
            ECU_REMOVE:                 'Delete',
            ECU_PARAMS:                 'Params',
            ECU_PARAMS_DESCR:           'Set the checkbox in the Data field to send the number in hexadecimal format. When requesting the status of parameters, the "Data" field with a yellow background means that the parameter has been created, but not sent to the GNSS block. The "Data" field with a green outline and a check mark indicates that the GNSS block receives the parameter.', 
            ECU_PARAMS_NO_INFO:         'No information about block parameters', 
            ECU_PARAMS_EMPTY:           'Block parameters are not set. Create them via the command submission form.',   
            ECU_PARAM_CREATE_SUCCESS:   'New parameter successfuly added', 
            ECU_PARAM_UPDATE:           'Param update', 
            ECU_PARAM_UPDATE_SUCCESS:   'Param successfuly updated', 
            ECU_PARAM_DELETE:           'Delete param', 
            ECU_PARAM_DELETE_TEXT:      'This setting will be permanently deleted. Are you sure you want to remove it?', 
            ECU_PARAM_DELETE_SUCCESS:   'The parameter was successfully removed from the block', 

            ECU_GNSS_REFRESH:           'Refresh reports',
            ECU_GNSS_REBOOT:            'Reboot GNSS',
            ECU_GNSS_FIRMWARES:         'Firmwares',
            ECU_GNSS_FIRMWARES_DELETE:  'Delete firmware file',
            ECU_GNSS_FIRMWARES_DELETE_DESCR: 'This firmware file will be deleted without the possibility of recovery. Are you sure you want to do this?',
            ECU_GNSS_FIRMWARES_DELETE_SUCCESS: 'The firmware file was successfully deleted',
            ECU_GNSS_LOGS:              'Logs',
            ECU_GNSS_LOGS_GEO:          'Navi info', 
            // ECU_GNSS_UPDATE_DIAG:       'Update Diag-CAN',
            ECU_GNSS_DESCR:             'Description',
            ECU_GNSS_SOFTWARE:          'Software',
            ECU_GNSS_UPDATE_NAVI:       'Navigation update',
            ECU_GNSS_MANUFACTORER:      'Manufactorer code',
            ECU_GNSS_CREATE_DATE:       'Hardware',
            ECU_GNSS_UPDATE_PARAMS:     'Update CAN',
            ECU_GNSS_MODIFICATION:      'Modification',
            ECU_GNSS_TID:               'id GNSS',
            ECU_GNSS_SET_SERVER:        'Set data-server',
            ECU_GNSS_DEBUG_PARAMS:      'Debug params', 
            ECU_GNSS_TELEMATIC:         'Set operating mode', 
            ECU_GNSS_TELEMATIC_ON:      'Enable telematic',
            ECU_GNSS_TELEMATIC_OFF:     'Disable telematic',
            ECU_GNSS_SEND_CMD:          'Send CMD',
            ECU_GNSS_ONLINE_DATE:       'Last contact time',
            ECU_GNSS_SET_PARAMS_TITLE:  'Params [set / check]',
            ECU_GNSS_CMD:               'Commands',
            ECU_GNSS_CMD_TITLE:         'CMD [params]', 
            ECU_MODULES_INFO:           'Modules', 
            ECU_MODULES_MAIN:           'General module', 
            ECU_MODULES_INTERFACE:      'Interface module', 
            ECU_MODULES_BOOTLOADER:     'Bootloader',
            ECU_MODULES_INFO_EMPTY:     'No information about device modules', 

            CMD_RESULT_NOT_SET:             'Status not set',
            CMD_RESULT_SEND_IN_PROCESS:     'Send in progress',
            CMD_RESULT_SEND_TIMEOUT:        'Send timeout',
            CMD_RESULT_SEND_CONFIRMED:      'Send confirmed',
            CMD_RESULT_RESULT_OK:           'The car sent the result of the command execution: successful execution',
            CMD_RESULT_RESULT_ERROR:        'The car sent the result of the command execution: error',
            CMD_RESULT_RESULT_ILL:          'The car sent the result of the command execution: error, absence from the list of allowed commands',
            CMD_RESULT_RESULT_DEL:          'The car sent the result of the command execution: successfully deleted',
            CMD_RESULT_RESULT_NOT_FOUND:    'The car sent the result of the command execution: the command to delete was not found',
            CMD_RESULT_RESULT_NOT_CONFIG:   'The car sent the result of the command execution: successful execution, negative response',
            CMD_RESULT_RESULT_IN_PROCESS:   'The car sent the result of the command execution: the command has been submitted for processing',
            CMD_SUCCESS:                    'Command sended',

            ECU_FIRMWARE_UPLOAD:        'Upload firmware',
            ECU_FIRMWARE_FILE:          'File',
            ECU_FIRMWARE_FILE_EMPTY:    'You are trying to upload an empty file', 
            ECU_FIRMWARE_FILE_LARGE:    'The firmware file is too large (maximum 2 MB)', 
            ECU_FIRMWARE_FILE_ERROR:    'Firmware file not selected', 
            ECU_FIRMWARE_TYPE:          'Type',
            ECU_FIRMWARE_TYPE_ALL:      'Universal',
            ECU_FIRMWARE_TYPE_ALL_EGTS: 'EGTS',
            ECU_FIRMWARE_TYPE_ALL_RLP:  'RLP',
            ECU_FIRMWARE_STATUS:        'Status',
            ECU_FIRMWARE_STATUS_OK:     'Successfully uploaded', 
            ECU_FIRMWARE_CREATE_SUCCESS:'The firmware file has been successfully uploaded to the server. Wait for the download to the device',
            ECU_FIRMWARE_DELETE_SUCCESS:'The firmware file has been successfully deleted',

            /**
             *  Car states
             * 
             * "STATE_" + state name in upper case
             */
            STATE_TABS_STATISTICS:              'Last trip',
            STATE_TABS_LAST_TRIP:               'Travel statistics',
            STATE_TABS_WHEELS:                  'Wheels pressure',
            STATE_TABS_BRAKES:                  'Brakes system',
            STATE_TABS_INTERIOR:                'Interior condition',
            STATE_TABS_TRANSMISSION:            'Transmission',
            STATE_TABS_BATTERY:                 'Battery',
            STATE_TABS_LIGHT:                   'Light',
            STATE_TABS_ENGINE:                  'Engine',
            STATE_TABS_DOORS:                   'Doors & body',
            STATE_TABS_ELECTRIC:                'Battery',

            STATE_INTERIOR_CHAIR_FL:            'Front left chair', 
            STATE_INTERIOR_CHAIR_FR:            'Front right chair', 
            STATE_INTERIOR_CHAIR_RL:            'Rear left chair', 
            STATE_INTERIOR_CHAIR_RR:            'Rear right chair', 
            STATE_INTERIOR_CHAIR_DESCR:         'Passengers in the car', 
            STATE_INTERIOR_CHAIR_LARGE:         'Adult', 
            STATE_INTERIOR_CHAIR_SMALL:         'Child', 
            STATE_INTERIOR_CHAIR_CHILD:         'Child seat', 
            STATE_INTERIOR_CHAIR_EMPTY:         'Empty', 
            STATE_INTERIOR_CHAIR_UNKNOWN:       'Unknown', 
            STATE_INTERIOR_CHAIR_ERROR:         'Error', 

            STATE_GROUP_BATTERY_12V:            'Battery 12V',
            STATE_GROUP_BATTERY_HW:             'Highvoltage battery',
            STATE_GROUP_LAST_TRIP:              'Last trip',
            STATE_GROUP_LAST_MONTH:             'Last month', 
            STATE_GROUP_AFTER_RESET:            'After reset',
            STATE_GROUP_LAST_EVENTS:            'Last events',

            STATE_DMFR_WARNING_INDICATOR: 'DMFR warning indicator', 
            STATE_DMFL_WARNING_INDICATOR: 'DMFL warning indicator', 
            STATE_DMRR_WARNING_INDICATOR: 'DMRR warning indicator', 
            STATE_DMRL_WARNING_INDICATOR: 'DMRL warning indicator', 

            STATE_DOOR_FRONT_RIGHT_CLOSED:  'Door front right closed', 
            STATE_DOOR_FRONT_LEFT_CLOSED:   'Door front left closed',
            STATE_DOOR_BACK_RIGHT_CLOSED:   'Door back right closed', 
            STATE_DOOR_BACK_LEFT_CLOSED:    'Door back left closed', 

            STATE_DOOR_FRONT_RIGHT:         'Door front right', 
            STATE_DOOR_FRONT_LEFT:          'Door front left',  
            STATE_DOOR_BACK_RIGHT:          'Door back right',  
            STATE_DOOR_BACK_LEFT:           'Door back left', 

            STATE_DOOR_HOOD:                'Door hood', 
            STATE_DOOR_TRUNK:               'Door trunk', 
            STATE_DOOR_TRUNK_DIRECTION:     'Door trunk direction', 

            STATE_CORNERING_LIGHT_RIGHT_STATUS: 'Cornering light right status', 
            STATE_CORNERING_LIGHT_LEFT_STATUS:  'Cornering light left status', 

            STATE_T30I_FAULT_STATUS:    'T30i fault status', 
            STATE_T15_FAULT_STATUS:     'T15 fault status', 
            STATE_T30D_FAULT_STATUS:    'T30d fault status', 
            STATE_SCU_FAULT_STATUS:     'SCU fault status',

            STATE_BRAKE_LIGHT_LEFT_STATUS:  'Brake light left status', 
            STATE_BRAKE_LIGHT_RIGHT_STATUS: 'Brake light right status', 
            STATE_BRAKE_LIGHT_HM_STATUS:    'Brake light HM status', 

            STATE_WHEEL_FRONT_RIGHT_STATUS: 'Wheel front right status', 
            STATE_WHEEL_FRONT_LEFT_STATUS:  'Wheel front left status', 
            STATE_WHEEL_BACK_RIGHT_STATUS:  'Wheel back right status', 
            STATE_WHEEL_BACK_LEFT_STATUS:   'Wheel back left status', 

            STATE_WHEEL_PRESSURE_STATUS_HIGH:       'High pressure',
            STATE_WHEEL_PRESSURE_STATUS_NORMAL:     'Normal pressure',
            STATE_WHEEL_PRESSURE_STATUS_LOW:        'Low pressure',
            STATE_WHEEL_PRESSURE_STATUS_CRITICAL:   'Critical low pressure!',
            STATE_WHEEL_PRESSURE_STATUS_ERROR:      'Error!',

            STATE_WHEEL_FRONT_RIGHT_PRESSURE:   'Wheel front right pressure', 
            STATE_WHEEL_FRONT_LEFT_PRESSURE:    'Wheel front left pressure', 
            STATE_WHEEL_BACK_RIGHT_PRESSURE:    'Wheel back right pressure', 
            STATE_WHEEL_BACK_LEFT_PRESSURE:     'Wheel back left pressure', 

            STATE_TURN_INDICATOR_FR_STATUS:     'Turn indicator FR status', 
            STATE_TURN_INDICATOR_FL_STATUS:     'Turn indicator FL status', 
            STATE_TURN_INDICATOR_MR_STATUS:     'Turn indicator MR status', 
            STATE_TURN_INDICATOR_ML_STATUS:     'Turn indicator ML status', 
            STATE_TURN_INDICATOR_RR_STATUS:     'Turn indicator RR status', 
            STATE_TURN_INDICATOR_RL_STATUS:     'Turn indicator RL status', 

            STATE_WINDOW_FULLY_CLOSED_FL:       'Window [front left]', 
            STATE_WINDOW_FULLY_CLOSED_FR:       'Window [front right]', 
            STATE_WINDOW_FULLY_CLOSED_RL:       'Window [rear left]', 
            STATE_WINDOW_FULLY_CLOSED_RR:       'Window [rear right]', 
            STATE_WINDOW_OPEN:                  'The window is open',

            STATE_TPMS_BATTERY_STATUS:          'TPMS battery status', 
            STATE_TPMS_BATTERY_STATUS_FR:       'TPMS battery status FR', 
            STATE_TPMS_BATTERY_STATUS_FL:       'TPMS battery status FL', 
            STATE_TPMS_BATTERY_STATUS_RR:       'TPMS battery status RR', 
            STATE_TPMS_BATTERY_STATUS_RL:       'TPMS battery status RL', 
            STATE_TPMS_BATTERY_NORMAL:          'Normal',
            STATE_TPMS_BATTERY_LOW:             'Low',

            STATE_ENGINE_TIME:                  'Engine hours',

            STATE_FRONT_RIGHT_TEMPERATURE:      'Front right temperature', 
            STATE_FRONT_LEFT_TEMPERATURE:       'Front left temperature', 
            STATE_FRONT_INSIDE_TEMPERATURE:     'Front inside temperature', 
            STATE_BACK_RIGHT_TEMPERATURE:       'Back right temperature', 
            STATE_BACK_LEFT_TEMPERATURE:        'Back left temperature', 
            STATE_BACK_INSIDE_TEMPERATURE:      'Back inside temperature', 
            
            STATE_TEMPERATURE_OUTSIDE:          'Outside temperature', 

            STATE_RIDE_AVERAGE_SPEED:           'Ride average speed', 
            STATE_OIL_PRESSURE_WARNING:         'Oil pressure warning', 
            STATE_IS_LOCKED:                    'Is locked', 

            STATE_STATUS: 'Status', 
            STATE_OIL_LEVEL: 'Oil level', 

            STATE_MIL_ONRQ: 'Mil onRq', 
            STATE_POSITION_LIGHT_FR_STATUS: 'Position light FR status', 
            STATE_HEAD_LIGHT_LEVELING_CTRL_FAILURE: 'Head light leveling ctrl failure', 
            STATE_LTC_COOLANT_LVL: 'LTC coolant lvl', 
            STATE_COOLANT_TEMPERATURE: 'Engine temperature',  
            STATE_RECEIVED_SIGNAL_STRENGTH_INDICATOR: 'Received signal strength indicator', 

            STATE_REVERSE_LIGHT_RIGHT_STATUS: 'Reverse light right status', 
            STATE_START_MOVING: 'Car start time', 
            STATE_STOP_MOVING: 'Car stop time', 
            // STATE_VEHICLE_SECURE_LOCK_STATE: 'Vehicle secure lock state', // State was deleted on backend
            STATE_REAR_FOG_LIGHT_STATUS: 'Rear fog light status', 
            STATE_ABS_LAMP: 'ABS lamp', 
            STATE_FRONT_RIGHT_FOG_LIGHT_STATUS: 'Front right fog light status', 
            STATE_POSITION_LIGHT_RR_STATUS: 'Position light RR status', 
            STATE_LOW_BEAM_RIGHT_STATUS: 'Low beam right status', 
            STATE_EPB_STATUS: 'Epb status', 
            STATE_ESP_LAMP: 'ESP lamp', 

            STATE_TPMS_SENSOR_FAULT_FR: 'TPMS sensor fault FR', 
            STATE_TPMS_SENSOR_FAULT_RL: 'TPMS sensor fault RL', 
            STATE_TPMS_SENSOR_FAULT_FL: 'TPMS sensor fault FL', 
            STATE_TPMS_SENSOR_FAULT_RR: 'TPMS sensor fault RR', 

            STATE_RIDE_MILEAGE: 'Ride mileage', 
            STATE_LAST_NAVIGATION_TIME: 'Last navigation time', 
            STATE_HV_SYSTEM_FAILURE: 'HV system failure', 
            STATE_FUEL: 'Fuel', 
            STATE_FRONT_LEFT_FOG_LIGHT_STATUS: 'Front left fog light status', 
            STATE_POSITION_LIGHT_RL_STATUS: 'Position light RL status', 
            STATE_BCM_WARNING_INDICATOR: 'BCM warning indicator', 
            STATE_ONLINE: 'Online', 
            STATE_OFFLINE: 'Offline',
            STATE_ENGINE_ON: 'Engine on', 
            STATE_DAYTIME_LIGHT_RIGHT_STATUS: 'Daytime light right status', 
            STATE_MOBILE_NETWORK_TYPE_INDICATOR: 'Mobile network type indicator', 
            STATE_POSITION_LIGHT_FL_STATUS: 'Position light FL status', 
            STATE_DAYTIME_LIGHT_LEFT_STATUS: 'Daytime light left status', 
            STATE_ENGINE_OIL_TEMP: 'Engine oil temp', 
            STATE_ENGINE_REV: 'Engine rev', 

            STATE_HIGH_BEAM_LEFT_STATUS: 'High beam left status', 

            STATE_TCS_LAMP: 'TCS lamp', 
            STATE_EBD_LAMP: 'EBD lamp', 
            // STATE_MILEAGE_ON_FUEL_RESIDUES: 'Mileage on fuel residues', // Old state
            STATE_ENGINE_TEMPERATURE: 'Engine temperature', 
            STATE_RIDE_TIME: 'Ride time', 
            STATE_ENGINE_OFF: 'Engine off', 
            STATE_WASHER_FLUID: 'Washer fluid', 
            STATE_WASHER_FLUID_WARNING: 'Low level of washing liquid',
            STATE_TOTAL_MILEAGE: 'Total mileage', 
            STATE_MIL_IND_BLINK: 'Mil ind blink', 
            STATE_COOLANT_FLUID: 'Coolant fluid', 
            STATE_COOLANT_FLUID_NORMAL: 'Normal',
            STATE_COOLANT_FLUID_LOW: 'Low',
            STATE_LOW_BEAM_LEFT_STATUS: 'Low beam left status', 
            STATE_RIDE_FUEL_CONSUMPTION: 'Ride fuel consumption', 
            STATE_ENGINE_OIL_LVIND: 'Engine oil level indicator', 
            STATE_HIGH_BEAM_RIGHT_STATUS: 'High beam right status', 
            STATE_ESP_SPEED: 'Esp speed', 
            STATE_LAST_CAN_PARAM_TIME: 'Last can param time', 
            STATE_TM_WARNING_INDICATOR: 'TM warning indicator', 
            STATE_REVERSE_LIGHT_LEFT_STATUS: 'Reverse light left status', 
            STATE_SERVICE_DATE: 'Service date',
            STATE_GEAR_POSITION: 'Gear position',
            STATE_LAST_ONLINE: 'Last online',
            STATE_SERVICE_MILEAGE: 'Service millage',
            STATE_ST_TRANSMISSION_WARNING: 'Transmission warning',
            STATE_SCU_CALIBRATION_STATUS: 'SCU calibration status',
            STATE_CCU_FAILURE: 'CCU failure',
            STATE_ERAG_FAILURE_STATUS: 'ERAG failure status',
            STATE_OPEN: 'Open',
            STATE_HALF_OPEN: 'Half open',
            STATE_CLOSED: 'Closed',
            STATE_NOT_CLOSED: 'Not closed',
            STATE_RESERV: '(reserve)',
            STATE_MILEAGE_WARNING: 'ATTENTION! The mileage recorded in this electronic unit is significantly different from the mileage stored in the ESP electronic unit',
            STATE_SDM_UPTIME: 'Last power on/restart', 
            STATE_VAS_ACTIVATION: 'Security alarm status', 
            STATE_LOCK_SECURE: 'Set on guard',
            STATE_CRUISING_RANGE: 'Mileage on fuel residues', 

            // Params after BC reset
            STATE_TOTAL_MILEAGE_AM: 'Total mileage after BC reset',
            STATE_TOTAL_AVG_SPEED_AM: 'Average speed after BC reset',
            STATE_TOTAL_MINS_AM: 'Time after BC reset',
            STATE_FUEL_CONSUMPTION: 'Fuel consumption after BC reset', 

            // Battery
            STATE_BAT_CAPACITY:     'Capacity',
            STATE_BAT_HEALTH:       'Health',
            STATE_BAT_STATUS:       'State',
            STATE_BAT_VOLTAGE:      'Voltage',
            STATE_LVB_SOH:          'Battery health',
            STATE_LVB_SOC:          'Battery capacity',
            STATE_BATTERY_STATUS:   'Battery 12V status', 
            STATE_BATTERY_VOLTAGE:  'Battery 12V voltage', 
            STATE_SOH_HV_AKB:       'HV Battery health',
            STATE_SOC_HV_AKB:       'HV battery capacity',

            STATE_COMMON_RIDE_TIME:         'Ride time', 
            STATE_COMMON_MILEAGE:           'Mileage', 
            STATE_COMMON_FUEL_CONSUMPTION:  'Fuel consumptision', 
            STATE_COMMON_AVERAGE_SPEED:     'Average speed', 

            STATE_OCU_FL_STAT:  'Front left seat', 
            STATE_OCU_FR_STAT:  'Front right seat', 
            STATE_OCU_RL_STAT:  'Rear left seat', 
            STATE_OCU_RR_STAT:  'Rear right seat', 

            STATE_SAT: 'Number of visible satellites', 

            STATE_TRIP_ACCELERATION:    'Number of accelerations', 
            STATE_TRIP_BRAKING:         'Number of braking times', 
            STATE_TRIP_DRIVING_ASSESSMENT: 'Driving assessment', 
            STATE_TOTAL_ACCELERATION:   'Number of accelerations (after reset)', 
            STATE_TOTAL_BRAKING:        'Number of braking times (after reset)', 
            STATE_ANS1:                 'ANS1',
            STATE_ANS2:                 'ANS2',
            STATE_ANS3:                 'ANS3',
            STATE_ANS4:                 'ANS4',
            STATE_ANS5:                 'ANS5',
            STATE_DIG1:                 'DIG1',
            STATE_DIG2:                 'DIG2',
            STATE_DIG3:                 'DIG3',
            STATE_DIG4:                 'DIG4',
            STATE_DIG5:                 'DIG5',
            STATE_ALARM_SYSTEM:         'Alarm System',
            STATE_SRC:                  'Source',
            STATE_CONN_TYPE:            'Connection type',
            STATE_MOV:                  'Movement',
            STATE_NOT_SET:              'Not set',

            // Connection type
            CONNECTION_ON:              'Online',
            CONNECTION_OFF:             'No connection',
            CONNECTION_LTE:             'LTE',
            CONNECTION_UMTS:            'UMTS',
            CONNECTION_GSM:             'GSM',

            ECUS_ADDITIONAL:                'Additional info',
            ECUS_STATUS_DESCR:              'Status description',
            ECUS_DESCR_BADGES:              'Badges',
            ECUS_DESCR_GNSS:                'GNSS',
            ECUS_DESCR_GNSS_ONLINE:         'GNSS online',
            ECUS_DESCR_GNSS_NOSATELLITES:   'GNSS online, no satellites connection',
            ECUS_DESCR_GNSS_OFFLINE:        'GNSS offline',
            ECUS_DESCR_ICON_ERROR:          'Number of active errors',
            ECUS_DESCR_ICON_PASSIVE:        'Number of passive errors',
            ECUS_DESCR_ICON_WARNING:        'Warnings',
            ECUS_DESCR_BG:                  'ECU colors',
            ECUS_DESCR_BG_ONLINE:           'Without errors / with passive errors',
            ECUS_DESCR_BG_OFFLINE:          'No diagnostics for more than 30 days',
            ECUS_DESCR_BG_ERROR:            'With active errors',
            ECUS_DESCR_BG_NO_INFO:          'No Data',

            ECUS_DIAG_REFRESH_SUCCESS:      'Diagnostics started. Report files will be updated',

            HISTORY:                        'Archive of states',
            HISTORY_DESCR:                  'View the history of states for a selected period of time',
            HISTORY_REQUEST_TEXT:           'Select the start and end time of the readings',
            HISTORY_START:                  'Start',
            HISTORY_END:                    'End',
            HISTORY_SEARCH:                 'Search by name...',
            HISTORY_PARAMS:                 'Params',
            HISTORY_TIME:                   'Time',
            HISTORY_ERROR_PARAMS:           'Params not selected!',
            HISTORY_ERROR_RANGE:            'The maximum interval for requesting charts is 31 days',
            HISTORY_ERROR_TIME_INCORRECT:   'The start time for recording graphs should be earlier than the end time',
            HISTORY_ERROR_TIME_EMPTY:       'Specify the start and end dates of the route',
            HISTORY_EMPTY_POINTS:           'No points recorded for the selected time interval',
            HISTORY_EMPTY_VALUE:            'No states recorded for the selected time interval',
            HISTORY_SHOW_GRID:              'Show grid',
            HISTORY_INSTRUCTION:            'Click on the chart with the left mouse button, then drag to enlarge the selected area. To move the chart, hold down Ctrl key',
            HISTORY_INSTRUCTION_PANNING:    'To zoom in, stretch the area on the graph. To shift the graph, swipe with two fingers',

            FORM_REQUIRED:              'Required fields', 

            RESET_TOKEN:                'End all sessions', 

            AGREE_PERSONAL_TEXT:        'By clicking "Register", you agree to the terms of the ', 
            AGREE_PERSONAL_LINK:        'license agreement',
            AGREE_PERSONAL_ERROR:       'License agreement', 
            
            PASS_INDICATOR_DESCR:       'Minimum 8 characters, one lowercase letter, one uppercase letter, one number and one _-%& symbol',
            PASS_INDICATOR_E_LENGHT:    'Minimum password length - 8 characters', 
            PASS_INDICATOR_E_LETTER:    'At least one lowercase and one uppercase letter', 
            PASS_INDICATOR_E_NUMBER:    'At least one number', 
            PASS_INDICATOR_E_SYMBOL:    'At least one symbol _ - % &', 

            FOOTER_COPYRIGHT:           'Developed by FSUE "NAMI", 2024 г.', 
            FOOTER_GOTOP:               'On top', 

            // 404
            NOTFOUND_SUBTITLE:            'Page not found',
            NOTFOUND_LINK:                'To the main',

            // Areas
            EAreaNotFound:                'Areas not found',
            AREAS:                        'Areas',
            AREAS_LIST:                   'Areas list',
            AREAS_DRAW_PANEL:             'Draw panel',
            AREA:                         'Area',
            AREA_CREATE:                  'Create area',
            AREA_DELETE:                  'Delete area',
            AREA_DELETE_QUESTION:         'This area will be permanently deleted. Are you sure you want to do this?',
            AREA_DELETE_SUCCESS:          'Area successfuly deleted',
            AREA_CREATE_SUCCESS:          'Area successfuly created',
            AREA_UPDATE_SUCCESS:          'Area successfuly updated',
            AREA_SEARCH_BY:               'Search by name, description',
            AREA_SEARCH_ENTER:            'Enter at least 3 sybmols',
            AREA_NAME:                    'Name',
            AREA_DESCRIPTION:             'Description',
            AREA_FIGURE:                  'Figure',
            AREA_FIGURE_TYPE:             'Figure type',
            AREA_RADIUS:                  'Radius',
            AREA_M:                       'm',
            AREA_STROKE_COLOR:            'Stroke color',
            AREA_FILL_COLOR:              'Fill color',
            AREA_WEIGHT:                  'Weight',
            AREA_OUTLINE:                 'Outline',
            AREA_ENTER_NAME:              'Enter name of area',
            AREA_ENTER_DESCRIPTION:       'Enter description of area',
            AREA_LAT:                     'Lat',
            AREA_LNG:                     'Lng',
            AREA_DRAW_FIGURE:             'Draw a figure',
            AREAS_UUID_NOT_FOUND:         'Uuid of area not found',
            AREAS_NOT_FOUND:              'Areas not found',

            // Геозоны автомобиля
            CAR_AREAS_CTRL_TITLE:         'Configure areas of car',
            CAR_AREAS_DELETE_TITLE:       'Delete event of cars area',
            CAR_AREAS_DELETE_TEXT:        'This event of cars area will be permanently deleted. Are you sure you want to delete it?',

            CAR_AREAS_AREA:               'Area',
            CAR_AREAS_EVENT:              'Event',
            // CAR_AREAS_NOT_FOUND:          'Event params not found',
            CAR_AREAS_CREATE_SUCCESS:     'Event of areas successfuly added',
            CAR_AREAS_SAVE_SUCCESS:       'Event of areas saved',
            CAR_AREAS_DELETE_SUCCESS:     'Event of areas deleted',

            FIRMWARES_TITLE:                'Firmwares', 
            FIRMWARES_FORM_METHOD:          'Upload method', 
            FIRMWARES_FORM_METHOD_CARS:     'Selected cars', 
            FIRMWARES_FORM_METHOD_GROUPS:   'Car groups', 
            FIRMWARES_FORM_METHOD_ALL:      'All cars', 
            FIRMWARES_FORM_SELECT_CARS:     'Add cars to download firmware.', 
            FIRMWARES_FORM_SELECT_GROUPS:   'Add car groups to download firmware.', 
            FIRMWARES_FORM_SELECT_WARNING:  'WARNING! You have chosen the download method - All cars. The selected firmware will be downloaded to all cars!', 
            FIRMWARES_FORM_DEVICE:          'Device version', 
            FIRMWARES_FORM_DEVICE_12:       'SDM v1.2', 
            FIRMWARES_FORM_DEVICE_30:       'SDM v3.0', 
            FIRMWARES_FORM_DEVICE_IC_217:   'NAMI-Intelcom 2.1.7', 
            FIRMWARES_FORM_DEVICE_IC_21713: 'NAMI-Intelcom 2.1.7 (1.3)', 
            FIRMWARES_FORM_DEVICE_IC_21714: 'NAMI-Intelcom 2.1.7 (1.4)', 
            FIRMWARES_FORM_FILE:            'Firmware file', 
            FIRMWARES_FORM_MODULE:          'Module', 
            FIRMWARES_FORM_VERSION:         'Firmware version', 
            FIRMWARES_CREATE_SELECT_ELEMENTS: 'Select elements for upload firmware', 
            FIRMWARES_CREATE_SUCCESS:       'Firmware successfuly uploaded', 
            FIRMWARES_UPDATE:               'Firmware info', 
            FIRMWARES_UPDATE_SUCCESS:       'Firmware info successfuly updated', 
            FIRMWARES_DELETE:               'Delete firmware', 
            FIRMWARES_DELETE_DESCR:         'The selected firmware file will be deleted. Devices that have not yet received this file or its download has not finished will not receive it. Are you sure you want to do this?', 
            FIRMWARES_DELETE_SUCCESS:       'Firmware successfuly deleted', 
            FIRMWARES_SEARCH_MODE_ALL:      'All', 
            FIRMWARES_SEARCH_MODE_DEVICE:   'Device type',  
            FIRMWARES_SEARCH_MODE_MODULE:   'Module', 
            FIRMWARES_SEARCH_MODE_VERSION:  'FIrmware version', 
            FIRMWARES_NAME:                 'File name', 
            FIRMWARES_DEVICE:               'Device', 
            FIRMWARES_MODULE:               'Module', 
            FIRMWARES_VERSION:              'Software', 
            FIRMWARES_SELECTOR:             'Select destination', 
            FIRMWARES_SELECTOR_LINK:        'Add', 

            ECaptchaError:              'Error when entering verification code', 
            EFormFields:                'Form filling error', 
            EEmail:                     'E-mail not found', 
            EUserPhoneAlreadyExist:     'Phone already exist', 
            EImei:                      'Incorrect IMEI', 
            EVin:                       'Incorrect VIN', 
            EUserNotFound:              'User not found', 
            EUserVerifyLink:            'Invalid account verification code', 
            EConnection:                'An error occurred while accessing the server. Please try again later.', 
            EUserEmailAlreadyExist:     'The specified e-mail is already registered',
            ECGroupNotFound:            'Cars groups not found', 
            ELinkNotFound:              'Links not found', 
            ECarNotFound:               'Cars not found', 
            ECarImeiAlreadyExist:       'A car with the same IMEI already exists', 
            ECarNotOnLine:              'Command execution error: no connection with vehicle', 
            ECarPointNotFound:          'No data found for the selected time interval',
            ELinkAlreadyExist:          'This link already exist',
            EUnknown:                   'An error occurred in the application. If this error persists, please contact your administrator.',
            EUGroupNotFound:            'Group not found',
            EEventNotFound:             'Events not found', 
            EEventsSubsUuid:            'Unknows car UUID', 
            EEgtsReportNotFound:        'Report files not found',
            ECommandResponseUnknownAddress: 'Error: unknown ECU identification',
            EEgtsFirmwareNotFound:      'Firmwares not found', 
            EPermissionDenied:          'You do not have access to this information', 
            EUserSelfUGroup:            'You cant change user group for youself', 
            EPassword:                  'The entered password does not meet the minimum requirements',
            EUserPassword:              'Error when entering password', 
            ELogNotFound:               'No reports found for the selected period', 
            EEmailOrPhone:              'User e-mail or phone error', 
            ECodeError:                 'Invalid verification code entered', 
            EUserIsNotActivated:        'Your account is not activated. Check the email address specified during registration and follow the link from the letter.',
            ECertificateNotFound:       'Certificate not found', 
            ECommandResponseNotRespond: 'ECU not respond',
            ECommandResponseUnknownCommand: 'Unknows command', 
            EIccid:                     'Invalid activation code', 
            EEventParamAlreadyExist:    'You already subscribed on this event', 
            ECarRequestOwnerICCIDVinMismatch: 'Invalid activation code',
            EQuery:                     'String contains characters other than unicode letters and numbers',
            EFavoriteFound:             "You haven't favorites cars", 
            EEventParamNotFound:        'Event of areas not found', 
            ECarTripsNotFound:          'Car trips not found',
            EEgtsFirmwareAlreadyExist:  'The firmware for this device has already been downloaded. To replace a firmware file, first delete the existing one.',

            TOKEN_BAD_REQUEST:          'Token request failed.',
            TOKEN_REPEAT_REQUEST:       'Repeat after'
        }
    }

    const getTranslate = computed(() => translates[langStore.lang])

    return {

        translates,
        getTranslate
    }
})
